/*jshint unused:false*/
/*global fetch */
/*global console */



// $(function () {

// /**** NAV SCROLL ****/
//     $(".side-nav a, .header-intro a, .footer-content a").click(function(e){
//         e.preventDefault();
//         // Hide nav
//         // Scroll to location
//         $("html, body").animate({ 
//             scrollTop: $( $(this).attr('href') ).position().top+50
//         }, 600);
//     });

// });

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}
let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}
window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

// Price toggles
function priceToggles() {
  let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
  let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
  let priceSwitchForm = document.getElementById('price-switch');
  let derivativeDropdown = document.querySelector('#quote-form select.quote-terms');
  let selected;
  allSwitches.forEach((value) => {

  if (derivativeDropdown){
    if(document.querySelector('.form-group[data-field="type"]').dataset.type === 'dropdown') {
      derivativeDropdown.addEventListener('change', (e) => {
        allSwitches.forEach((v) => {
          (e.target.selectedIndex === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
        })
      })
    }
  }

    value.addEventListener('change', (val) => {
      (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;

      if (derivativeDropdown){
        if(document.querySelector('.form-group[data-field="type"]').dataset.type === 'dropdown') {
          (selected) ? derivativeDropdown.selectedIndex = 1 : derivativeDropdown.selectedIndex = 0;
        }
      }

      if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
        (val.target.checked === true) ? selected = 1 : selected = 0;
      }

      toggleSwitches();
      togglePrices();
      updatePrice();
    })
  })
  let toggleSwitches = () => {
    allSwitches.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
      (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
    })
    document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
    document.querySelectorAll(".price-title-type").forEach((v) => {
      v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
    })
  }
  let togglePrices = () => {
    priceContainers.forEach((v) => {
      (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
      (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    })
  }
  let updatePrice = () => {
    let url = priceSwitchForm.getAttribute('action');
    let formData = new FormData(priceSwitchForm);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
}
priceToggles();
// End price Toggles

//Nav Toggle
function toggleNav(el) {
  var element = el;
  var menu = document.getElementById("site-menu");
  var header = document.querySelectorAll(".site-header")[0];
  menu.classList.toggle("active");
  header.classList.toggle("active");

  if(element.querySelector("span").classList.contains("more")){
    element.innerHTML = "<span class='close'></span> Close";
  } else {
    element.innerHTML = "<span class='more'></span> Menu";
  }
}
// Toggle Compare Nav Dropdown
document.querySelector('.compare-btn>a').addEventListener('click', (e)=>{ e.target.parentElement.classList.toggle('active') })


const searchSorter = document.querySelector('#search-sorter');
if (searchSorter) {
  searchSorter.addEventListener('change', (e) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('order', e.target.value);
    window.location.search = urlParams;
  })
}


// const modelSorter = document.querySelector('#model-sorter');
// if (modelSorter) {
//   modelSorter.addEventListener('change', (e) => {
//     const urlParamsModel = new URLSearchParams(window.location.search);
//     urlParamsModel.set('order', e.target.value);
//     window.location.search = urlParamsModel;
//   })
// }

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('.manufacturer-bar');
if(showMoreButton){
  if (showMoreButton.parentElement.querySelectorAll('.header-description > *').length > 1) {
    showMoreButton.addEventListener('click', (e) => {
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}


// Toggle class for accordions
let acc = document.getElementsByClassName('mobile-accordion-header');
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(ev) {

    for (let i = 0; i < acc.length; i++) {
      if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
        continue;
      }
      acc[i].parentElement.classList.remove('active');
    }

    if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
      setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
    }
    this.parentElement.classList.toggle("active");

  });
}

//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }


//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }



//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
  e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
  classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}



/**
 * SEARCH
 */

// Search Sidebar
function setUrlParams(param, value, module, multiple ) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);
  if (module === 'Search') {
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
  }
  if(param==='type'){
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.set('spec_level', '');
    searchUrl.searchParams.set('body_type', '');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside [name="make"]') ? document.querySelector('.search-aside [name="make"]').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside [name="model"]') ? document.querySelector('.search-aside [name="model"]').value : ''));
    searchUrl.searchParams.set('spec_level', param==='spec_level' ? value : (document.querySelector('.search-aside [name="spec_level"]') ? document.querySelector('.search-aside [name="spec_level"]').value : ''));
    searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside [name="body_type"]') ? document.querySelector('.search-aside [name="body_type"]').value : ''));
    if(param==='make'){
      searchUrl.searchParams.delete('model');
      searchUrl.searchParams.delete('spec_level');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='model'){
      searchUrl.searchParams.delete('spec_level');
      searchUrl.searchParams.delete('body_type');
    }
  }
  if(param==='term' && document.querySelector('.search-aside .search-term input:checked')===null){
    searchUrl.searchParams.set('term', '');
  } else{
    searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-aside .search-term input:checked') ? document.querySelector('.search-aside .search-term input:checked').value : ''));
  }
  if(param==='initial_profile' && document.querySelector('.search-aside .search-initial input:checked')===null){
    searchUrl.searchParams.set('term', '');
  } else{
    searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-aside .search-initial input:checked') ? document.querySelector('.search-aside .search-initial input:checked').value : ''));
  }
  if(param==='mileage' && document.querySelector('.search-aside .search-mileage input:checked')===null){
    searchUrl.searchParams.set('term', '');
  } else{
    searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-aside .search-mileage input:checked') ? document.querySelector('.search-aside .search-mileage input:checked').value : ''));
  }

  searchUrl.searchParams.set('budget', param==='budget' ? value : (document.querySelector('.search-aside [name="budget"]') ? document.querySelector('.search-aside [name="budget"]').value : ''));
  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside [name="transmission"]') ? document.querySelector('.search-aside [name="transmission"]').value : ''));
  searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside [name="fuel_type"]') ? document.querySelector('.search-aside [name="fuel_type"]').value : ''));
  searchUrl.searchParams.set('co2', param==='co2' ? value : (document.querySelector('.search-aside [name="co2"]') ? document.querySelector('.search-aside [name="co2"]').value : ''));
  var orderVal = '';

  if (param === 'order') {
    orderVal = value;
  } else if (document.querySelector('.search-content-heading select[name="order"]')) {
    orderVal = document.querySelector('.search-content-heading select[name="order"]').value;
  } else if (document.querySelector('.search-filters-mobile select[name="order"]')) {
    orderVal = document.querySelector('.search-filters-mobile select[name="order"]').value;
  } else if (document.querySelector('form.used-search')) {
    orderVal = 'price_asc';
  }

  searchUrl.searchParams.set('order', orderVal);


  window.location.href = searchUrl;
}

// Show Only Filters
function updateSearchToggles() {
  let searchToggles = document.querySelectorAll('.search-filters input');
  if (searchToggles) {
    searchToggles.forEach(value => {
      value.addEventListener('change', (e) => {
        let searchUrl = new URL(window.location.origin + '/car-leasing');
        let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
        (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
        (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
        (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
        (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
        (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=specials', 'offers=stock')) : null;
        (e.target.value === 'stock' && e.target.checked && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('?', '?offers=stock&')) : null;
        (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
        (e.target.value === 'stock' && !e.target.checked && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;

        document.body.classList.remove('loaded');
        window.location.href = searchUrl;
      })
    })
  }
}
// END Show Only Filters

function loadSearchTriggers() {
  if (document.querySelector('.search-aside')) {
    if (document.querySelector('.search-aside #search-type')) {
      if (document.querySelector('.search-aside [name="make"]').value!=='') {
        loadModels(document.querySelector('.search-aside #search-type').value, document.querySelector('.search-aside [name="make"]').value)
      } else {
        loadManufacturers(document.querySelector('.search-aside #search-type').value)
      }
    }

    document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="spec_level"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('spec_level', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="budget"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="transmission"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="fuel_type"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside [name="co2"]').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('co2', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside .search-term input').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside .search-initial input').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelectorAll('.search-aside .search-mileage input').forEach(v => {
      v.addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    })
    document.querySelector('.search-content-heading select[name="order"]').addEventListener('change', e => {
      document.body.classList.remove('loaded');
      setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
    })

    if(document.querySelector('.search-filters-mobile select[name="order"]') !== null) {
      document.querySelector('.search-filters-mobile select[name="order"]').addEventListener('change', e => {
        document.body.classList.remove('loaded');
        setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
      })
    }

  }
}

function updateMobileResults() {
  if(!updateMobileResultsBtn.classList.contains('visuallyhidden')) {

    // Show dynamic options
    if (document.querySelector('#search-type') && document.querySelector('.search-aside')) {
      if (document.querySelector('.search-aside [name="make"]')) {
        document.querySelector('.search-aside [name="make"]').addEventListener('change', e => {
          loadModels(document.querySelector('#search-type').value, document.querySelector('.search-aside [name="make"]').value);
          loadSpecs(document.querySelector('#search-type').value, document.querySelector('.search-aside [name="model"]').value);
          loadBodyTypes(document.querySelector('#search-type').value);
          loadTransmissionTypes(document.querySelector('#search-type').value);
          loadFuelTypes(document.querySelector('#search-type').value);
        })
      }

      if (document.querySelector('.search-aside [name="model"]')) {
        document.querySelector('.search-aside [name="model"]').addEventListener('change', e => {
          loadSpecs(document.querySelector('#search-type').value, document.querySelector('.search-aside [name="model"]').value);
          loadBodyTypes(document.querySelector('#search-type').value);
          loadTransmissionTypes(document.querySelector('#search-type').value);
          loadFuelTypes(document.querySelector('#search-type').value);
        })
      }

      if (document.querySelector('.search-aside [name="spec_level"]')) {
        document.querySelector('.search-aside [name="spec_level"]').addEventListener('change', e => {
          loadBodyTypes(document.querySelector('#search-type').value);
          loadTransmissionTypes(document.querySelector('#search-type').value);
          loadFuelTypes(document.querySelector('#search-type').value);
        })
      }

      if (document.querySelector('.search-aside [name="body_type"]')) {
        document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
          v.addEventListener('change', e => {
            loadTransmissionTypes(document.querySelector('#search-type').value);
            loadFuelTypes(document.querySelector('#search-type').value);
          })
        })
      }
    }

    // Unselect checkboxes
    function handleCheckboxSelection(groupSelector) {
      const checkboxes = document.querySelectorAll(groupSelector);

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          // Uncheck all checkboxes except the current one
          checkboxes.forEach((cb) => {
            if (cb !== checkbox) {
              cb.checked = false;
            }
          });
        });
      });
    }

    handleCheckboxSelection('.tingle-modal #search-form .search-term input');
    handleCheckboxSelection('.tingle-modal #search-form .search-initial input');
    handleCheckboxSelection('.tingle-modal #search-form .search-mileage input');

    updateMobileResultsBtn.addEventListener('click', e => {
      document.querySelectorAll('.tingle-modal #search-form .search-term input:checked') ? document.querySelectorAll('.tingle-modal #search-form .search-term input:checked').forEach(v => { v.setAttribute('name', 'term') }) : null;
      document.querySelectorAll('.tingle-modal #search-form .search-initial input:checked') ? document.querySelectorAll('.tingle-modal #search-form .search-initial input:checked').forEach(v => { v.setAttribute('name', 'initial_profile') }) : null;
      document.querySelectorAll('.tingle-modal #search-form .search-mileage input:checked') ? document.querySelectorAll('.tingle-modal #search-form .search-mileage input:checked').forEach(v => { v.setAttribute('name', 'mileage') }) : null;

      document.getElementById('search-form').submit();
      document.body.classList.remove('loaded');
    })
  }
}


function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  const evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  hiddenField.dispatchEvent(evt);

  document.getElementsByName('spec_level')[0] ? loadSpecs() : null;

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  loadBodyTypes(document.querySelector('#search-type').value);

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  // alert("loadManufacturers");
  let defaultOption = document.createElement('option');
  defaultOption.text = 'Any Manufacturer';
  defaultOption.value = '';
  let loadingOption = document.createElement('option');
  loadingOption.text = 'Loading...';
  loadingOption.value = '';
  let loadingError = document.createElement('option');
  loadingError.text = 'Loading Error, please check your internet connection';
  loadingError.value = '';

  var make_dropdowns = Array.from(document.querySelectorAll(".search-aside select[name=make]")).filter(el => !el.closest('form.used-search'));
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }

      // console.log('loadManufacturers');

      loadModels($type, document.querySelector('.search-aside [name="make"]').value);

    }).catch(function(err) {
      dropdown.length = 0;
      dropdown.add(loadingError);
      dropdown.selectedIndex = 0;
      console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {

  let defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';
  let loadingOption = document.createElement('option');
  loadingOption.text = 'Loading...';
  loadingOption.value = '';
  let loadingError = document.createElement('option');
  loadingError.text = 'Loading Error, please check your internet connection';
  loadingError.value = '';

  // var model_dropdowns = document.getElementsByName("model");
  var model_dropdowns = document.querySelectorAll(".search-aside select[name=model]");
  for (i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;

      var url = '/api/'+$type+'/models/'+$manufacturer+'/available';

      if(document.querySelector('form.search-form')){
        if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
          url += '?specials=true';
        }
        if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
          url += '?stock=true';
        }
      }

      // console.log('loadModels')
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const makeParam = urlParams.get('make');
        const modelParam = urlParams.get('model');
        if (modelParam && makeParam == $manufacturer) {
          dropdown.value = modelParam;
          loadSpecs($type, modelParam);
          loadBodyTypes($type);
          loadTransmissionTypes($type);
          loadFuelTypes($type);

          // if (document.getElementsByClassName('search-aside').length > 0){
          //   if (!document.body.classList.contains('tingle-enabled')) {
          //     document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
          //       v.addEventListener('change', e => {
          //         document.body.classList.remove('loaded');
          //         setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          //       })
          //     })
          //   }
          // }

        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    } else {
      loadBodyTypes($type);
      loadTransmissionTypes($type);
      loadFuelTypes($type);
    }

  }

}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec_level')[0];
  if (dropdown){
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Spec';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($model) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;
      var url = '/api/'+$type+'/specs/'+$model+'?available';

      if(document.querySelector('form.search-form')){
        if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
          url += '&specials=true';
        }
        if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
          url += '&stock=true';
        }
      }

      // console.log('loadSpecs')
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        let selectedSpec = new URLSearchParams(window.location.search).get('spec_level');
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          (selectedSpec && (keysSorted[x] === selectedSpec)) ? option.setAttribute('selected', 'true') : null;
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const modelParam = urlParams.get('model');
        const specParam = urlParams.get('spec_level');
        if (specParam && modelParam == $model) {
          dropdown.value = specParam;
        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    }
  }
}

function loadBodyTypes($type) {
  let dropdown = document.querySelector('[name=body_type]');
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Bodytype';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/'+$type+'/types?available';

    url += document.querySelector('.search-aside [name="make"]').value!='' ? '&make='+document.querySelector('.search-aside [name="make"]').value : '';
    url += document.querySelector('.search-aside [name="model"]').value!='' ? '&model='+document.querySelector('.search-aside [name="model"]').value : '';
    if (document.querySelector('.search-aside [name="spec_level"]')) {
      url += document.querySelector('.search-aside [name="spec_level"]').value!='' ? '&spec_level='+document.querySelector('.search-aside [name="spec_level"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        (selectedBodyType && (keysSorted[x] === selectedBodyType)) ? option.setAttribute('selected', 'true') : null;
        dropdown.add(option);
      }

      // if (!document.body.classList.contains('tingle-enabled')) {
      //   if (document.querySelectorAll('.search-aside [name="body_type"]')) {
      //     document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
      //       v.addEventListener('change', e => {
      //         document.body.classList.remove('loaded');
      //         setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
      //         // setUrlParams('body_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
      //       })
      //     })
      //   }
      // }

    }).catch(function(err) {
      dropdown.length = 0;
      dropdown.add(loadingError);
      dropdown.selectedIndex = 0;
      console.error('Fetch Error -', err);
    });
  }
}

function loadTransmissionTypes($type) {
  let dropdown = document.querySelector('[name=transmission]');
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Transmission';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/'+$type+'/transmissions?available';

    url += document.querySelector('.search-aside [name="make"]').value!='' ? '&make='+document.querySelector('.search-aside [name="make"]').value : '';
    url += document.querySelector('.search-aside [name="model"]').value!='' ? '&model='+document.querySelector('.search-aside [name="model"]').value : '';
    if (document.querySelector('.search-aside [name="spec_level"]')) {
      url += document.querySelector('.search-aside [name="spec_level"]').value!='' ? '&spec_level='+document.querySelector('.search-aside [name="spec_level"]').value : '';
    }
    if (document.querySelector('.search-aside [name="body_type"]')) {
      url += document.querySelector('.search-aside [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-aside [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      let selectedTransmissionType = new URLSearchParams(window.location.search).get('transmission');
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        (selectedTransmissionType && (keysSorted[x] === selectedTransmissionType)) ? option.setAttribute('selected', 'true') : null;
        dropdown.add(option);
      }

      // if (!document.body.classList.contains('tingle-enabled')) {
      //   document.querySelectorAll('.search-aside [name="transmission"]').forEach(v => {
      //     v.addEventListener('change', e => {
      //       document.body.classList.remove('loaded');
      //       setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
      //     })
      //   })
      // }

    }).catch(function(err) {
      dropdown.length = 0;
      dropdown.add(loadingError);
      dropdown.selectedIndex = 0;
      console.error('Fetch Error -', err);
    });
  }
}

function loadFuelTypes($type) {
  let dropdown = document.querySelector('[name=fuel_type]');
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Fuel Type';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/'+$type+'/fuel-types?available';

    url += document.querySelector('.search-aside [name="make"]').value!='' ? '&make='+document.querySelector('.search-aside [name="make"]').value : '';
    url += document.querySelector('.search-aside [name="model"]').value!='' ? '&model='+document.querySelector('.search-aside [name="model"]').value : '';
    if (document.querySelector('.search-aside [name="spec_level"]')) {
      url += document.querySelector('.search-aside [name="spec_level"]').value!='' ? '&spec_level='+document.querySelector('.search-aside [name="spec_level"]').value : '';
    }
    if (document.querySelector('.search-aside [name="body_type"]')) {
      url += document.querySelector('.search-aside [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-aside [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
      (window.location.pathname === '/electric-leasing' || window.location.pathname === '/van-leasing/electric' || window.location.pathname === '/hybrid-leasing' || window.location.pathname === '/van-leasing/hybrid') ? dropdown.parentElement.parentElement.classList.add('visuallyhidden') : dropdown.parentElement.parentElement.classList.remove('visuallyhidden')
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      delete data['B'];
      delete data['R'];
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      let selectedFuelType = new URLSearchParams(window.location.search).get('fuel_type');
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        (selectedFuelType && (keysSorted[x] === selectedFuelType)) ? option.setAttribute('selected', 'true') : null;
        dropdown.add(option);
      }

      // if (!document.body.classList.contains('tingle-enabled')) {
      //   document.querySelectorAll('.search-aside [name="fuel_type"]').forEach(v => {
      //     v.addEventListener('change', e => {
      //       document.body.classList.remove('loaded');
      //       setUrlParams('fuel_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
      //     })
      //   })
      // }

    }).catch(function(err) {
      dropdown.length = 0;
      dropdown.add(loadingError);
      dropdown.selectedIndex = 0;
      console.error('Fetch Error -', err);
    });
  }
}

// Subscribe Form
if(document.getElementById('email-signup')){
  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    var recaptcha_token = null;

    if(document.querySelector('input[name=g-recaptcha-response]')){
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
    } else {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
        recaptcha_token = token;
      });
    }

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = '<span class="loading">Please wait<span>';
    document.getElementById('email-signup').disabled = true;

    let url = (typeof $base_path !== 'undefined' ? $base_path : '')+'/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let forename = document.getElementById('newsletter-forename').value;
    let surname = document.getElementById('newsletter-surname').value;
    let token = document.getElementsByName('_token')[0].value;

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({ 'first_name': forename, 'last_name': surname, 'full_name': forename + ' ' + surname, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;

      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Whoops!',
            html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          return alert('There was a problem with your sign up details\n\n'+errors);
        }
      }

      document.getElementsByClassName('newsletter-form')[0].reset();
      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Form Submit'
      });

      if(typeof Swal !== 'undefined'){
        return Swal.fire({
          title: 'Thank you!',
          text: 'You\'re signed up!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        return alert('Thank you!');
      }

    }).catch(function(err) {
      console.error('Fetch Error -', err);
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;
    });
  });
}

// Contact Form
if(document.getElementById('send-contact-form')){
// Do captcha and submit form

  let button = document.querySelector('#send-contact-form');
  let terms = document.querySelector('#contact-form [name=consent]');
  terms.onchange = function() {
    button.disabled = !this.checked;
  };

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();

    document.body.classList.remove('loaded');

    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        var url = '/contact';
        var email = document.getElementsByName('email')[0].value;
        var firstName = document.getElementsByName('name')[0].value;
        var secondName = document.getElementsByName('surname')[0].value;
        var company = document.getElementsByName('company')[0].value;
        var telephone = document.getElementsByName('telephone')[0].value;
        var comments = document.getElementsByName('comments')[0].value;
        var token = document.getElementsByName('_token')[0].value;
        var recaptcha = document.querySelector('input[name=g-recaptcha-response]').value;

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'name': firstName,
            'surname': secondName,
            'company': company,
            'email': email,
            'telephone': telephone,
            'comments': comments,
            '_token': token,
            'g-recaptcha-response': recaptcha
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status!='ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            return alert('There was a problem with your form\n\n'+errors);
          }

          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'Contact Form Submit'
          });


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });

      });
    });

  });
}
// END Contact Form

document.addEventListener("DOMContentLoaded", function() {
  // Sort Model Table
  // let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  // [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;
  const lazyLoad = function() {
    if (active === false) {
      active = true;
      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });
      active = false;
    }
  };
  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();
  //END Lazy Load Images

  // Share Toggle
  const shareContainer = document.querySelector('.share-links');
  if (shareContainer){
    shareContainer.querySelector('.share-front').addEventListener('click', () => {
      shareContainer.querySelector('.share-front').classList.add('invisible');
      shareContainer.querySelector('.share-back').classList.remove('invisible');
    })
  }

  // Bodytype Filters
  const filters = document.querySelector('#bodytype-filter');
  const filtersDropdown = document.querySelector('#bodytype-dropdown');
  const rangeBoxes = document.querySelectorAll('.range-list .range-box');
  if (filters) {
    filters.querySelectorAll('input').forEach((value) => {
      value.addEventListener('change', (e) => {
        filtersDropdown.value = e.target.value;
        rangeBoxes.forEach((value) => {
          value.classList.add('hidden');
          if (value.dataset.bodytypes.includes(e.target.value)){
            // console.log(value.dataset.bodytypes);
            value.classList.remove('hidden');
          }
        })
      })
    })
  }
  if (filtersDropdown) {
    filtersDropdown.addEventListener('change', (e) => {
      // console.log(e.target.value);
      filters.querySelector(`input[value="${e.target.value}"]`).checked = true;
      rangeBoxes.forEach((value) => {
        value.classList.add('hidden');
        if (value.dataset.bodytypes.includes(e.target.value)){
          // console.log(value.dataset.bodytypes);
          value.classList.remove('hidden');
        }
      })
    })
  }
  // END Bodytype Filters


// Gauges
  if (document.querySelector('#charging-speeds')) {
    const gaugeOpts = {
      angle: -0.25, lineWidth: 0.18, radiusScale: 1, strokeColor: '#F2F3F3',
      generateGradient: true, gradientType:1, highDpiSupport: true,
      pointer: { length: 0.58, strokeWidth: 0.04, color: '#082239' }
    }
    const opts = { colorStart: '#3488D3', colorStop: '#41D29C'};

    function runGauge($target, $opts, $animationSpeed, $maxValue) {
      if ($target){
        let gauge = new Gauge($target).setOptions({...gaugeOpts, ...$opts});
        gauge.maxValue = $maxValue;
        gauge.setMinValue(0);
        gauge.animationSpeed = $animationSpeed;
        gauge.set(($maxValue - $target.dataset.minutes));
      }
    }

    let chargingSpeedsSection = document.getElementById('charging-speeds').getBoundingClientRect();
    let offsetToTriggerAnimation = chargingSpeedsSection.y + (chargingSpeedsSection.height/4);
    function scrollAnimTriggerCheck() {
      let viewBottom = window.scrollY + window.innerHeight;
      if (viewBottom > (document.querySelector('#charging-speeds').offsetTop)+500) {
        runGauge(document.getElementById('gaugeHome'), opts, 500, 1440);
        runGauge(document.getElementById('gaugeFast'), opts, 400, 1440);
        runGauge(document.getElementById('gaugeRapid'), opts, 300, 1440);
        runGauge(document.getElementById('gaugeUltraRapid'), opts, 200, 1440);
        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }
  // END Derivative Gallery Slider

  // Car Leasing Slider
  const carSlider = document.querySelector('.car-slider');
  if (carSlider) {
    new Glider(carSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.5,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3.5,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4.5,
          }
        }
      ]
    })
  }
  // END Car Leasing Slider

  // Van Leasing Slider Slider
  const vanSlider = document.querySelector('.van-slider');
  if (vanSlider) {
    new Glider(vanSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.5,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3.5,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4.5,
          }
        }
      ]
    })
  }
  // END Van Leasing Slider


//Dropdown Menu Toggle
  const showMenu = function(){
    let allMenuToggles = this.parentElement.parentElement.querySelectorAll('.dropdown-menu > a');
    let allDropdowns = this.parentElement.parentElement.querySelectorAll('.dropdown-menu > .dropdown');
    let menuToggle = this;
    let dropdown = this.nextElementSibling;

    allMenuToggles.forEach((value) => {
      if (value !== menuToggle) {
        value.classList.remove("active");
        value.classList.remove("is-active");
      } else {
        menuToggle.classList.toggle("active");
        menuToggle.classList.toggle("is-active");
      }
    })

    allDropdowns.forEach((value) => {
      if (value !== dropdown) {
        value.classList.remove("active");
        value.classList.remove("is-active");
      } else {
        dropdown.classList.toggle("active");
        dropdown.classList.toggle("is-active");
      }

    })
  }
  document.querySelectorAll(".dropdown-menu > a").forEach((value) => {
    value.addEventListener('click', showMenu, false);
  })

  // Derivative Review Show More
  let reviewMore = document.querySelector('.review-content');
  let toggleLink = document.querySelector('.review-content .show-all > a');
  if (reviewMore && toggleLink) {
    toggleLink.addEventListener('click', (e) => {
      reviewMore.classList.toggle('active');
      reviewMore.classList.contains('active') ? toggleLink.querySelector('span').innerHTML = 'Show Less' : toggleLink.querySelector('span').innerHTML = 'Read Full Review'
    })
  }


  // Table Sorting
  function sortTable(elem, name, direction) {
    let sortName,sortDirection;
    if (name && direction) {
      sortName = name;
      sortDirection = direction;
    } else {
      sortName = elem.composedPath()[0].dataset.sortname;
      sortDirection = elem.composedPath()[0].dataset.sortdirection;
    }
    let tableBody = document.querySelector('.model-table-body');
    let tableRows = Array.from(tableBody.children);
    tableRows.pop();

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      if (sortName === 'price') {
        return (dir === 'asc') ? b.localeCompare(a, 'en', {numeric: true}) : a.localeCompare(b, 'en', {numeric: true});
      }
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }

  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  let sortDropdown = document.querySelector('#table-sorter');
  if (sortDropdown) {
    sortDropdown.addEventListener('change', (e) => {
      (e.target.value === 'price_asc') ? sortTable(null, 'price', 'desc') : null;
      (e.target.value === 'price_desc') ? sortTable(null, 'price', 'asc') : null;
      (e.target.value === 'offers') ? sortTable(null, 'offer', 'asc') : null;
      (e.target.value === 'stock') ? sortTable(null, 'stock', 'asc') : null;
    })
  }

  // Show no results text
  const showNoResults = function() {
    if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
      document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
    } else {
      document.querySelector('.no-results').classList.add('hidden-no-results');
    }
  }

  // Show stock offers only
  let checkboxStock = document.querySelector('.search-checkbox-switch [name=stock]');
  let modelNonStockDeals = document.querySelectorAll('#model-table .model-table-wrapper[data-stock="0"]');
  if(checkboxStock && modelNonStockDeals){
    checkboxStock.addEventListener('change', (ev) => {
      if (ev.target.checked === true) {
        modelNonStockDeals.forEach((value) => {
          value.classList.add('visuallyhidden')
          showNoResults();
        })
      } else {
        modelNonStockDeals.forEach((value) => {
          value.classList.remove('visuallyhidden')
          showNoResults();
        })
      }
    })
  }

  // Model Table Search (filters)
  if (document.querySelector('#filters-form')) {
    let filterFields = document.querySelectorAll('#filters-form .filters input');
    const filterTable = (field, value) => {
      let searchType = field;

      if (value !== '' && value.length > 0) {
        let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');
        elements.forEach((v) => {
          v.classList.add('hidden-' + field + '')
          if(v.getAttribute('data-' + searchType + '').includes(value)) {
            v.classList.remove('hidden-' + field + '')
          }
        })
      } else {
        document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
          v.classList.remove('hidden-' + field + '')
        });
      }

      // Show no results text
      showNoResults();
    }
    if (filterFields) {
      filterFields.forEach((value => {
        value.addEventListener('change', (event) => {
          let val = value.value;
          let field = value.getAttribute('name');

          filterTable(field, val);

          if(val===field +"-any"){
            document.querySelectorAll('.model-table-wrapper[data-' + field + ']').forEach((v) => {
              v.classList.remove('hidden-' + field + '')
              showNoResults()
            });
          }
        })
      }))
    }
  }
  // End Model Table Search

// Model Table Terms
  function loadTablePrices(vehicleType, vehicleIds) {
    let priceView, term, profile, mileage;
    priceView = (document.querySelector('#switch-price-type')) ? document.querySelector('#switch-price-type').value : null;
    // console.log(priceView);
    term = (document.querySelector('#filters-form input[name="term"]:checked')) ? document.querySelector('#filters-form input[name="term"]:checked').value : null;
    profile = (document.querySelector('#filters-form input[name="profile"]:checked')) ? document.querySelector('#filters-form input[name="profile"]:checked').value : null;
    mileage = (document.querySelector('#filters-form input[name="mileage"]:checked')) ? document.querySelector('#filters-form input[name="mileage"]:checked').value : null;
    tags = document.querySelector('#filters-form input[name="tags"]') ? document.querySelector('#filters-form input[name="tags"]').value : null;

    // add loaders
    document.querySelectorAll('.price-from > div.active').forEach(element => element.classList.add('price-loader'));
    document.querySelectorAll('.filter-form-terms').forEach(element => element.classList.add('filter-loader'));

    let url = `/api/${vehicleType}/price/bulk?${vehicleIds}term=${term}&initial_profile=${profile}&mileage=${mileage}&price_view=${priceView}&tags=${tags}`;
    fetch(url, {
      method: 'GET',
      // body: formData,
    }).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function (data) {
      if(data){
        data.forEach((v, i) => {
          if (v) {
            if (vehicleType === 'van') {
              document.querySelector(`.model-table-wrapper[data-id="${v.van_id}"] .price-from > div.active span.dyn-price`).innerHTML = (v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA';
              // document.querySelector(`.model-table-wrapper[data-id="${v.van_id}"] .price-from > div.active .price-terms-ctr .dyn-rental`).innerHTML = (v.initial_payment) ? `£${v.initial_payment.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}&nbsp;Initial Rental` : null;
              // document.querySelector(`.model-table-wrapper[data-id="${v.van_id}"] .price-from > div.active .price-terms-ctr .dyn-contract`).innerHTML = (v.term) ? `${v.term}&nbsp;Month Contract` : null;
              // document.querySelector(`.model-table-wrapper[data-id="${v.van_id}"] .price-from > div.active .price-terms-ctr .dyn-miles`).innerHTML = (v.mileage) ? `${v.mileage}&nbsp;Miles pa` : null;
            } else {
              document.querySelector(`.model-table-wrapper[data-id="${v.car_id}"] .price-from > div.active span.dyn-price`).innerHTML = (v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA';
              // document.querySelector(`.model-table-wrapper[data-id="${v.car_id}"] .price-from > div.active .price-terms-ctr .dyn-rental`).innerHTML = (v.initial_payment) ? `£${v.initial_payment.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}&nbsp;Initial Rental` : null;
              // document.querySelector(`.model-table-wrapper[data-id="${v.car_id}"] .price-from > div.active .price-terms-ctr .dyn-contract`).innerHTML = (v.term) ? `${v.term}&nbsp;Month Contract` : null;
              // document.querySelector(`.model-table-wrapper[data-id="${v.car_id}"] .price-from > div.active .price-terms-ctr .dyn-miles`).innerHTML = (v.mileage) ? `${v.mileage}&nbsp;Miles pa` : null;
            }
          } else {
            document.querySelector(`.model-table-wrapper:nth-child(${i+1}) .price-from > div.active span.dyn-price`).innerHTML = 'POA';
          }
        })
        // remove loaders
        document.querySelectorAll('.price-from > div.active').forEach(element => element.classList.remove('price-loader'));
        document.querySelectorAll('.filter-form-terms').forEach(element => element.classList.remove('filter-loader'));
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
  if (document.querySelector('#filters-form') && document.querySelectorAll('.model-table-body > .model-table-wrapper:not(.no-results)').length > 0) {
    let tableRows = document.querySelectorAll('.model-table-body > .model-table-wrapper:not(.no-results)');
    let vehicleIds = '';
    let vehicleType = document.querySelector('.model-table-body > .model-table-wrapper:not(.no-results)').dataset.type;
    tableRows.forEach(v => {
      vehicleIds += `ids[]=${v.dataset.id}&`
    })

    loadTablePrices(vehicleType, vehicleIds)

    document.querySelectorAll('#filters-form > .form-group.filter-form-terms, .price-toggle').forEach(value => {
      value.addEventListener('change', e => {
        loadTablePrices(vehicleType, vehicleIds)
      })
    })
  }
  // End Model Table Terms


// Calculators
  if (document.querySelector('body').classList.contains('page-tools')) {
    function numberWithCommas(x) {
      if (x === 0) { return '0' }
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
    // Next Step
    document.querySelectorAll('.next-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
        value.parentElement.parentElement.nextElementSibling.classList.add('active')
      })
    })
    // Back Step
    document.querySelectorAll('.back-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
        value.parentElement.parentElement.previousElementSibling.classList.add('active')
      })
    })
    // Steps Progress Bar
    document.querySelectorAll('.next-step, .back-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        let percent = value.dataset.percent;
        document.querySelector('#progress').value = (percent == 0) ? 1 : percent;
        document.querySelector('#progress-text').innerHTML = percent;
      })
    })
    // Indicative Fuel Cost
    function indicativeCost($fuel_type = false, $mpg = null, $electric_range = null, $battery_size = null, $electricity_cost = null) {
      let indicativeCost;
      if ($fuel_type === 'Electric' && $electric_range && $battery_size){
        let electricity_cost = ($electricity_cost) ? $electricity_cost : document.getElementById('average-data').dataset.averageElectricity;
        let miles_per_kwh = $electric_range / $battery_size;
        let cost_per_mile = electricity_cost / miles_per_kwh;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type === 'Diesel' && $mpg) {
        let cost_per_litre_diesel = document.getElementById('average-data').dataset.averageDiesel;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_diesel / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type !== false && $mpg) {
        let cost_per_litre_petrol = document.getElementById('average-data').dataset.averagePetrol;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_petrol / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else {
        indicativeCost = 'N/A';
      }
      (indicativeCost == 'Infinity') ? indicativeCost = 'N/A' : null;
      return indicativeCost;
    }

    function equalHeight($el_1, $el_2) {
      let leftHeight = $el_1.clientHeight;
      let rightHeight = $el_2.clientHeight;
      $el_1.setAttribute('style', '');
      $el_2.setAttribute('style', '');
      setTimeout(() => {
        if (leftHeight > rightHeight) {
          $el_1.style.height=leftHeight+'px';
          $el_2.style.height=leftHeight+'px';
        }
        if (leftHeight < rightHeight) {
          $el_1.style.height=rightHeight+'px';
          $el_2.style.height=rightHeight+'px';
        }
      }, 500);
    }

    // Load Manufacturers Dropdown
    function loadManufacturersCalc($type, $ev = true) {
      var make_dropdowns = document.getElementsByName("calculator-make");
      for (i = 0; i < make_dropdowns.length; i++) {

        var dropdown = make_dropdowns[0];
        dropdown.length = 0;

        var defaultOption = document.createElement('option');
        defaultOption.text = 'Select Manufacturer';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;

        let url;
        ($ev) ? url = '/api/' + $type + '/manufacturers/ev' : url = '/api/' + $type + '/manufacturers';

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }
    // Load Models Dropdown
    function loadModelsCalc($type, $manufacturer, $ev = true, $inactive = false, $compare = false) {
      let model_dropdowns, derivative_dropdowns;
      ($compare) ? model_dropdowns = document.getElementsByName("calculator-model-compare") : model_dropdowns = document.getElementsByName("calculator-model");
      ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
      for (let i = 0; i < derivative_dropdowns.length; i++) {
        let dropdown = derivative_dropdowns[i];
        dropdown.length = 0;
        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select Variant';
        defaultOption.value = '';
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
      }
      for (let i = 0; i < model_dropdowns.length; i++) {
        let dropdown = model_dropdowns[i];
        dropdown.length = 0;

        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select Model';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;

        let url;
        ($ev) ? url = '/api/' + $type + '/models/' + $manufacturer + '/ev' : url = '/api/' + $type + '/models/' + $manufacturer;

        let params;
        ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';

        fetch(url + params).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }
    // Load Derivatives Dropdown
    function loadDerivativeCalc($type, $model, $default = false, $ev = true, $inactive = false, $compare = false, $distinct = true, $non_ev = false, $van_size = false) {
      let derivative_dropdowns;
      ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
      for (let i = 0; i < derivative_dropdowns.length; i++) {
        let dropdown = derivative_dropdowns[i];
        dropdown.length = 0;

        if ($default){
          let defaultOption = document.createElement('option');
          defaultOption.text = 'Select Variant';
          defaultOption.value = '';

          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
        }

        let url;
        ($ev) ? url = '/api/' + $type + '/derivatives/' + $model + '/ev' : url = '/api/' + $type + '/derivatives/' + $model + ($non_ev ? '/nonev' : '');

        let params;
        if($compare) {
          ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive', 'compare_ev': 'true'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
        } else {
          ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
        }
        if ($van_size) {
          params += '&van_size=true';
        }
        fetch(url + params).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if ($distinct) {
            let distinct = []
            for (const key in data) {
              if (!distinct.includes(data[key])) {
                distinct.push(data[key]);
              } else {
                delete data[key];
              }
            }
          }

          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            if (x === '2813'){ continue }
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }
    // Compare Cars
    if (document.querySelector('.tools-main>div').classList.contains('car-comparison')) {
      loadManufacturersCalc('car', true);
      let comparisonTable = document.getElementById('car-comparison')
      let makeField = document.querySelector('select[name=calculator-make]')
      let modelField = document.querySelector('select[name=calculator-model]')
      let derivativeField = document.querySelector('select[name=calculator-derivative]')

      function compareColumns(row, reverse = false, blue = false) {
        let largest = 0
        let smallest = 9999
        comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
          if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
            (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
            (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
            if(largest !== smallest) {
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
            }
          }
        })
      }

      function loadPrice($spot, $derivative) {
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

        document.querySelector('input[name="car_id"]').value = $derivative;
        let url = '/api/car/price/' + $derivative;
        let formData = new FormData(document.getElementById('car-comparison'));
        fetch(url, {
          method: 'POST',
          body: formData,
        }).then(function (response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function (data) {
          if (data) {
            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.monthly_rental).toFixed(2)) : 'N/A';
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
            compareColumns('price', true);
            // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
            // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
            // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
            // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
            // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
            // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
          }
        }).catch(function (err) {
          console.error('Fetch Error -', err);
          document.getElementsByClassName('price')[0].classList.remove('hidden');
          document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
        });
      }

      function setLinks($spot, $active, $url, $fuel) {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
      }

      function loadVehicle($spot, $derivative) {
        if ($derivative !== 0) {
          let url = '/api/car/' + $derivative;
          let params = '?' + new URLSearchParams({'type': (document.querySelector('#car-comparison input[name=type]')).value});
          fetch(url + params).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            let getCapTechnicalData;
            if(data.car.technical) {
              getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
            } else {
              getCapTechnicalData = ($category, $term) => 'N/A';
            }
            comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

            comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
            comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .derivative`).innerText = data.car.name;

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');

            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('onerror', `this.src="${data.car.main_img}"`);
            data.car.main_img.includes('/std/') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img.replace('/std/', '/big/')) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

            setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

            comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + numberWithCommas((parseFloat(data.car.base_price)).toFixed(0)) : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
            (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
            compareColumns('electric-range');
            comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
            (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
            compareColumns('real-electric-range');

            comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
            (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
            compareColumns('official-mpg');
            comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
            (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
            compareColumns('real-mpg');

            let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
            comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
            (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
            compareColumns('indicative-cost', true);

            // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
            comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? parseInt(data.car.co2).toFixed(0) + ' g/km' : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

            if (data.car.tax_band) {
              comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
              (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
              compareColumns('first-year-rate', true);
              comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
              (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
              compareColumns('year-rate', true);
            }

            if (data.car.fuel_type === 'Petrol') {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
            } else if (data.car.fuel_type === 'Diesel') {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
            } else if (data.car.fuel_type === 'Electric') {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            } else {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            }

            if (data.car.tax) {
              comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
              (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
              compareColumns('bik-1', true);
              comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
              (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
              compareColumns('bik-2', true);
              comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
              (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
              compareColumns('bik-3', true);
            }

            if (data.car.from_price) {
              comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.car.from_price.monthly_rental).toFixed(2)) : 'N/A';
              (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
              compareColumns('price', true);
              comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
              (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
              comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
              (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
              comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
              (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
            }

            comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
            (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
            compareColumns('engine-size', false, true);
            comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
            comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
            (parseInt(getCapTechnicalData('Performance', 'Engine Power - BHP').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
            compareColumns('engine-power', false, true);
            comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
            (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
            compareColumns('acceleration', false, true);
            comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
            (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
            compareColumns('top-speed', false, true);
            if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
              for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
                let star = document.createElement("img");
                star.setAttribute('src', '/themes/bluepoppy/img/icons/general/star-gold.svg');
                comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
              }
            } else {
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            }
            comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

            ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

            // loadModelsCalc('car', 0, true, false)
            loadModelsCalc('car', 0, false, true)

            loadPrice($spot, $derivative)

            comparisonTable.reset();
          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }
      }

      function updateParams() {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        comparisonTable.querySelectorAll(`[data-cell-content="cta_top"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
          let url;
          (value.getAttribute('href').split('?')[0].includes('/car-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
          value.setAttribute('href', url);
        })
      }


      document.querySelectorAll('.quote-terms').forEach((value) => {
        value.addEventListener('change', (ev) => {
          loadPrice('first', document.querySelector('#car-comparison').dataset.carFirst);
          loadPrice('second', document.querySelector('#car-comparison').dataset.carSecond);
          loadPrice('third', document.querySelector('#car-comparison').dataset.carThird);
          updateParams();
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
        })
      })

      document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
        value.addEventListener('click', (ev) => {
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
        })
      })

      makeField.addEventListener('change', () => {
        (makeField.value > 0) ? loadModelsCalc('car', makeField.value, false, false) : false;
      })

      modelField.addEventListener('change', () => {
        (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, false, true, false) : false;
        derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
      });

      setTimeout(() => {
        (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
      }, 200);
      setTimeout(() => {
        (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
      }, 400);
      setTimeout(() => {
        if (comparisonTable.dataset.carThird > 1) {
          loadVehicle('third', comparisonTable.dataset.carThird);
          comparisonTable.setAttribute('data-car-form', '0');
        }
      }, 1000);

      derivativeField.addEventListener('change', (event) => {
        if(event.target.value > 0) {

          if(parseInt(comparisonTable.dataset.carFirst) < 1) {
            loadVehicle('first', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
            loadVehicle('second', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
            loadVehicle('third', event.target.value)
          } else { }

          let cookie = Cookies.get('compare_list')
          let range_name = derivativeField.dataset.range
          if (cookie) {
            let cookie_obj = JSON.parse(cookie);
            if (Object.keys(cookie_obj).length < 3) {
              if (cookie_obj[event.target.value] === undefined) {
                cookie_obj = {...cookie_obj, [event.target.value] : range_name};
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list', cookie_string)
              }
            }
          } else {
            let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
          }

        }
      })

      function resetSlot($slot, $id) {
        comparisonTable.setAttribute('data-car-form', '1');
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
        if ($slot === 'first') {
          comparisonTable.setAttribute('data-car-first', '-1');
        } else if ($slot === 'second') {
          comparisonTable.setAttribute('data-car-second', '-1');
        } else {
          comparisonTable.setAttribute('data-car-third', '-1');
        }

        let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
        [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
          if (index === 0) {
            (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
            (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
            (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
            let cookie = Cookies.get('compare_list');
            let cookie_obj = JSON.parse(cookie);
            delete cookie_obj[$id];
            (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          }
        })

      }
      document.querySelectorAll('div[data-car] .reset').forEach(value => {
        value.addEventListener('click', evt => {
          comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
          (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
          (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
          (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
        })
      })

    }

    // Compare Vans
    if (document.querySelector('.tools-main>div').classList.contains('van-comparison')) {
      loadManufacturersCalc('van', true);
      let comparisonTable = document.getElementById('van-comparison')
      let makeField = document.querySelector('select[name=calculator-make]')
      let modelField = document.querySelector('select[name=calculator-model]')
      let derivativeField = document.querySelector('select[name=calculator-derivative]')

      function compareColumns(row, reverse = false, blue = false) {
        let largest = 0
        let smallest = 9999
        comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
          if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
            (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
            (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
            if(largest !== smallest) {
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
            }
          }
        })
      }

      function loadPrice($spot, $derivative) {
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

        document.querySelector('input[name="van_id"]').value = $derivative;
        let url = '/api/van/price/' + $derivative;
        let formData = new FormData(document.getElementById('van-comparison'));
        fetch(url, {
          method: 'POST',
          body: formData,
        }).then(function (response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function (data) {
          if (data) {
            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.monthly_rental).toFixed(2)) : 'N/A';
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
            compareColumns('price', true);
            // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
            // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
            // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
            // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
            // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
            // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
          }
        }).catch(function (err) {
          console.error('Fetch Error -', err);
          document.getElementsByClassName('price')[0].classList.remove('hidden');
          document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
        });
      }

      function setLinks($spot, $active, $url, $fuel) {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
      }

      function loadVehicle($spot, $derivative) {
        if ($derivative !== 0) {
          let url = '/api/van/' + $derivative;
          let params = '?' + new URLSearchParams({'type': (document.querySelector('#van-comparison input[name=type]')).value});
          fetch(url + params).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            let getCapTechnicalData;
            if(data.car.technical) {
              getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
            } else {
              getCapTechnicalData = ($category, $term) => 'N/A';
            }
            comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

            comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
            comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .derivative`).innerText = getCapTechnicalData('General', 'Relative Length') ? data.car.name + ' - ' + getCapTechnicalData('General', 'Relative Length').value : data.car.name;

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');

            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('onerror', `this.src="${data.car.main_img}"`);
            data.car.main_img.includes('/std/') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img.replace('/std/', '/big/')) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

            setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

            comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + numberWithCommas((parseFloat(data.car.base_price)).toFixed(0)) : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
            (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
            compareColumns('electric-range');
            comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
            (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
            compareColumns('real-electric-range');

            comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
            (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
            compareColumns('official-mpg');
            comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
            (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
            compareColumns('real-mpg');

            let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
            comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
            (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
            compareColumns('indicative-cost', true);

            // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
            comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? parseInt(data.car.co2).toFixed(0) + ' g/km' : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

            // if (data.car.tax_band) {
            //   comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
            //   (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
            //   compareColumns('first-year-rate', true);
            //   comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
            //   (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
            //   compareColumns('year-rate', true);
            // }

            comparisonTable.querySelector(`[data-cell-content="van-height"] [data-car=${$spot}] span`).innerText = (data.car.height) ? parseInt(data.car.height).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.height) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-height"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.height) : '';
            compareColumns('van-height');
            comparisonTable.querySelector(`[data-cell-content="van-length"] [data-car=${$spot}] span`).innerText = (data.car.length) ? parseInt(data.car.length).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.length) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.length) : '';
            compareColumns('van-length');
            comparisonTable.querySelector(`[data-cell-content="van-wheel_base"] [data-car=${$spot}] span`).innerText = (data.car.wheel_base) ? parseInt(data.car.wheel_base).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.wheel_base) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-wheel_base"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.wheel_base) : '';
            compareColumns('van-wheel_base');
            comparisonTable.querySelector(`[data-cell-content="van-load_width"] [data-car=${$spot}] span`).innerText = (data.car.load_width) ? parseInt(data.car.load_width).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.load_width) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_width"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_width) : '';
            compareColumns('van-load_width');
            comparisonTable.querySelector(`[data-cell-content="van-load_height"] [data-car=${$spot}] span`).innerText = (data.car.load_height) ? parseInt(data.car.load_height).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.load_height) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_height"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_height) : '';
            compareColumns('van-load_height');
            comparisonTable.querySelector(`[data-cell-content="van-load_length"] [data-car=${$spot}] span`).innerText = (data.car.load_length) ? parseInt(data.car.load_length).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.load_length) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_length) : '';
            compareColumns('van-load_length');
            comparisonTable.querySelector(`[data-cell-content="van-payload"] [data-car=${$spot}] span`).innerText = (data.car.payload) ? parseInt(data.car.payload).toFixed(0) + ' kg' : 'N/A';
            (parseInt(data.car.payload) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-payload"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.payload) : '';
            compareColumns('van-payload');
            comparisonTable.querySelector(`[data-cell-content="van-load_space"] [data-car=${$spot}] span`).innerText = (data.car.load_space) ? parseInt(data.car.load_space).toFixed(0) + ' m3' : 'N/A';
            (parseInt(data.car.load_space) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_space"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_space) : '';
            compareColumns('van-load_space');
            // if (data.car.fuel_type === 'Petrol') {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
            // } else if (data.car.fuel_type === 'Diesel') {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
            // } else if (data.car.fuel_type === 'Electric') {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            // } else {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            // }

            // if (data.car.tax) {
            //   comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
            //   (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
            //   compareColumns('bik-1', true);
            //   comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
            //   (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
            //   compareColumns('bik-2', true);
            //   comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
            //   (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
            //   compareColumns('bik-3', true);
            // }

            if (data.car.from_price) {
              comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.car.from_price.monthly_rental).toFixed(2)) : 'N/A';
              (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
              compareColumns('price', true);
              comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
              (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
              comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
              (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
              comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
              (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
            }

            comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
            // (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
            // compareColumns('engine-size', false, true);
            // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
            comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
            (getCapTechnicalData('Performance', 'Engine Power - BHP')) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
            compareColumns('engine-power', false, true);
            comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
            (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
            compareColumns('acceleration', false, true);
            // comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
            // (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
            // compareColumns('top-speed', false, true);
            if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
              for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
                let star = document.createElement("img");
                star.setAttribute('src', '/themes/lcvgroup/img/icons/general/star-gold.svg');
                comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
              }
            } else {
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            }
            comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

            ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

            // loadModelsCalc('car', 0, true, false)
            loadModelsCalc('van', 0, false, true)

            loadPrice($spot, $derivative)

            comparisonTable.reset();
          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }
      }

      function updateParams() {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        comparisonTable.querySelectorAll(`[data-cell-content="cta_top"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
          let url;
          (value.getAttribute('href').split('?')[0].includes('/van-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
          value.setAttribute('href', url);
        })
      }


      document.querySelectorAll('.quote-terms').forEach((value) => {
        value.addEventListener('change', (ev) => {
          loadPrice('first', document.querySelector('#van-comparison').dataset.carFirst);
          loadPrice('second', document.querySelector('#van-comparison').dataset.carSecond);
          loadPrice('third', document.querySelector('#van-comparison').dataset.carThird);
          updateParams();
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
        })
      })

      document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
        value.addEventListener('click', (ev) => {
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
        })
      })

      makeField.addEventListener('change', () => {
        (makeField.value > 0) ? loadModelsCalc('van', makeField.value, false, false) : false;
      })

      modelField.addEventListener('change', () => {
        (modelField.value > 0) ? loadDerivativeCalc('van', modelField.value, true, false, true, false, true, false, true) : false;
        derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
      });

      setTimeout(() => {
        (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
      }, 200);
      setTimeout(() => {
        (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
      }, 400);
      setTimeout(() => {
        if (comparisonTable.dataset.carThird > 1) {
          loadVehicle('third', comparisonTable.dataset.carThird);
          comparisonTable.setAttribute('data-car-form', '0');
        }
      }, 1000);

      derivativeField.addEventListener('change', (event) => {
        if(event.target.value > 0) {

          if(parseInt(comparisonTable.dataset.carFirst) < 1) {
            loadVehicle('first', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
            loadVehicle('second', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
            loadVehicle('third', event.target.value)
          } else { }

          let cookie = Cookies.get('compare_list_vans')
          let range_name = derivativeField.dataset.range
          if (cookie) {
            let cookie_obj = JSON.parse(cookie);
            if (Object.keys(cookie_obj).length < 3) {
              if (cookie_obj[event.target.value] === undefined) {
                cookie_obj = {...cookie_obj, [event.target.value] : range_name};
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list_vans', cookie_string)
              }
            }
          } else {
            let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list_vans', cookie_string)
          }

        }
      })

      function resetSlot($slot, $id) {
        comparisonTable.setAttribute('data-car-form', '1');
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
        if ($slot === 'first') {
          comparisonTable.setAttribute('data-car-first', '-1');
        } else if ($slot === 'second') {
          comparisonTable.setAttribute('data-car-second', '-1');
        } else {
          comparisonTable.setAttribute('data-car-third', '-1');
        }

        let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
        [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
          if (index === 0) {
            (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
            (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
            (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
            let cookie = Cookies.get('compare_list_vans');
            let cookie_obj = JSON.parse(cookie);
            delete cookie_obj[$id];
            (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
          }
        })

      }
      document.querySelectorAll('div[data-car] .reset').forEach(value => {
        value.addEventListener('click', evt => {
          comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
          (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
          (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
          (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
        })
      })

    }
    // // Journey Cost Calculator
    // if (document.querySelector('.tools-main>div').classList.contains('journey-calculator')) {
    //   loadManufacturersCalc('car', true);
    //   let makeField = document.querySelector('select[name=calculator-make]')
    //   let modelField = document.querySelector('select[name=calculator-model]')
    //   let derivativeField = document.querySelector('select[name=calculator-derivative]')
    //   let makeFieldCompare = document.querySelector('select[name=calculator-make-compare]')
    //   let modelFieldCompare = document.querySelector('select[name=calculator-model-compare]')
    //   let derivativeFieldCompare = document.querySelector('select[name=calculator-derivative-compare]')
    //   let milesField = document.querySelector('input[name=journey-calculator-miles]')
    //   let electricityField = document.querySelector('input[name=journey-calculator-electricity]')
    //   let electricityLabel = document.querySelector('.electricity-cost-label')
    //   let makeText = document.querySelectorAll('.step-four-make')
    //   let modelText = document.querySelectorAll('.step-four-model')
    //   let stepOneNext = document.querySelector('#step-one-next')
    //   let stepTwoNext = document.querySelector('#step-two-next')
    //   let averageValue, charger_rate, journey_distance, journey_cost, annual_journey_cost, co2, img_url, electric_range, battery_capacity;
    //   let comparable_london, comparable_ulez, comparable_journey_cost, comparable_annual_journey_cost, comparable_co2, comparable_img_url, comparable_mpg, comparable_type;
    //   let ev_loaded, ice_loaded = false;
    //
    //   function loadVehicle($derivative, $ev = false) {
    //     let url = '/api/car/' + $derivative;
    //     fetch(url).then(function(response) {
    //       if (response.status !== 200) {
    //         console.warn('Looks like there was a problem. Status Code: ' + response.status);
    //         return;
    //       }
    //       return response.json();
    //     }).then(function(data) {
    //       // console.log(data)
    //       let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : null;
    //       if ($ev) {
    //         // nox = ((getCapTechnicalData('Emissions - ICE', 'NOx') != null && isNaN(getCapTechnicalData('Emissions - ICE', 'NOx') != 'Not Available'))) ? 'Not Available': getCapTechnicalData('Emissions - ICE', 'NOx').value + 'mg';
    //         electric_range = (data.car.electric_range != null) ? data.car.electric_range : ((data.car.technical) ? ((getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)')) ? parseFloat(getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)').value) : null) : null);
    //         battery_capacity = data.car.battery_capacity;
    //         // miles_per_kWh = (getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (miles/kWh) - Comb')) ? getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (miles/kWh) - Comb').value : ( (getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (kWh/100km) - Comb')) ? ( 100 / 1.609344 / parseFloat(getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (kWh/100km) - Comb').value)) : null);
    //         co2 = (data.car.co2) ? data.car.co2 : 0;
    //         img_url = data.car.main_img;
    //         // comparable_car = data.car.non_ev_comparable_car;
    //         // setTimeout(() => { loadVehicle(data.car.non_ev_comparable_car, false) }, 500);
    //         setTimeout(() => {
    //           if (electric_range && battery_capacity) {
    //             ev_loaded = true;
    //             document.getElementById('no-data').classList.add('visuallyhidden');
    //             (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ice_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
    //           } else {
    //             ev_loaded = false;
    //             stepOneNext.classList.add('disabled');
    //             document.getElementById('no-data').classList.remove('visuallyhidden');
    //           }
    //         }, 1000);
    //
    //         let compareButton = document.querySelector('button[data-compare]');
    //         if (compareButton) {
    //           compareButton.dataset.compare = data.car.id;
    //           compareButton.dataset.name = data.car.model_name;
    //           compareButton.setAttribute('title', `Compare ${data.car.model_name} deal`);
    //           compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/bluepoppy/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
    //           compareButton.dataset.compareAdded = 'false';
    //           let cookie = Cookies.get('compare_list');
    //           if (cookie) {
    //             let cookie_obj = JSON.parse(cookie);
    //             if (cookie_obj[compareButton.dataset.compare] !== undefined) {
    //               compareButton.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/bluepoppy/img/minus.svg#minus"></use></svg>&nbsp;Remove`;
    //               compareButton.dataset.compareAdded = 'true';
    //             }
    //           }
    //         }
    //
    //         document.querySelectorAll('.step-four-derivative').forEach(v => { v.innerHTML = derivativeField.options[derivativeField.selectedIndex].text });
    //       } else {
    //         comparable_type = data.car.fuel_type;
    //         if (comparable_type === 'Electric') {
    //           setTimeout(() => {
    //             ice_loaded = false;
    //             stepOneNext.classList.add('disabled');
    //             document.getElementById('no-ice-two').classList.remove('visuallyhidden');
    //           }, 500);
    //         } else {
    //           // comparable_nox = ((getCapTechnicalData('Emissions - ICE', 'NOx') != null && isNaN(getCapTechnicalData('Emissions - ICE', 'NOx') != 'Not Available'))) ? 'Not Available': getCapTechnicalData('Emissions - ICE', 'NOx').value + 'mg';
    //           comparable_img_url = data.car.main_img;
    //           comparable_co2 = (data.car.co2) ? data.car.co2 : 0;
    //           comparable_mpg = (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra);
    //           if (comparable_type === 'Petrol') {
    //             comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
    //             comparable_ulez = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? 12.50 : 0) : 0;
    //           } else if (comparable_type === 'Diesel') {
    //             comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
    //             comparable_ulez = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? 12.50 : 0) : 0;
    //           } else {
    //             comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
    //             comparable_ulez = 0;
    //           }
    //           setTimeout(() => {
    //             if (comparable_mpg && comparable_mpg != '0.00' && comparable_co2) {
    //               ice_loaded = true;
    //               document.getElementById('no-data-two').classList.add('visuallyhidden');
    //               document.getElementById('no-ice-two').classList.add('visuallyhidden');
    //               (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ev_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
    //             } else {
    //               ice_loaded = false;
    //               stepOneNext.classList.add('disabled');
    //               document.getElementById('no-data-two').classList.remove('visuallyhidden');
    //             }
    //           }, 1000);
    //         }
    //         document.querySelectorAll('.step-four-derivative-second').forEach(v => { v.innerHTML = derivativeFieldCompare.options[derivativeFieldCompare.selectedIndex].text });
    //       }
    //     }).catch(function(err) {
    //       console.error('Fetch Error -', err);
    //     });
    //   }
    //
    //   // First Step
    //   makeField.addEventListener('change', () => {
    //     (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : null;
    //     (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
    //     derivativeField.classList.add('visuallyhidden')
    //     Array.prototype.slice.call(makeText, 0).forEach((value) => {
    //       value.innerHTML = makeField.options[makeField.selectedIndex].text
    //     })
    //     let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
    //     document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
    //
    //     document.getElementById('no-data').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //   })
    //   modelField.addEventListener('change', () => {
    //     (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, false, false) : null; // inactive reversed
    //
    //     Array.prototype.slice.call(modelText, 0).forEach((value) => {
    //       value.innerHTML = modelField.options[modelField.selectedIndex].text
    //     })
    //     let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
    //     document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
    //     derivativeField.classList.remove('visuallyhidden')
    //
    //     document.getElementById('no-data').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //
    //     setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null }, 500);
    //   })
    //   derivativeField.addEventListener('change', () => {
    //     stepOneNext.classList.add('disabled');
    //     document.getElementById('no-data').classList.add('visuallyhidden');
    //     (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null;
    //   })
    //
    //   // Second Step
    //   makeFieldCompare.addEventListener('change', () => {
    //     (makeFieldCompare.value > 0) ? loadModelsCalc('car', makeFieldCompare.value, false, false, true) : null;
    //     (modelFieldCompare.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
    //     derivativeFieldCompare.classList.add('visuallyhidden')
    //     document.querySelector('.step-four-make-second').innerHTML = makeFieldCompare.options[makeFieldCompare.selectedIndex].text;
    //     let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase();
    //     document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond);
    //     document.getElementById('no-data-two').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //   })
    //   modelFieldCompare.addEventListener('change', () => {
    //     (modelFieldCompare.value > 0) ? loadDerivativeCalc('car', modelFieldCompare.value, false, false, false, true, true, true) : null;
    //     document.querySelector('.step-four-model-second').innerHTML = modelFieldCompare.options[modelFieldCompare.selectedIndex].text;
    //
    //     let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelFieldCompare.options[modelFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
    //     document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond)
    //
    //     derivativeFieldCompare.classList.remove('visuallyhidden')
    //
    //     document.getElementById('no-data-two').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //
    //     setTimeout(() => { (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null }, 500);
    //   })
    //   derivativeFieldCompare.addEventListener('change', () => {
    //     stepOneNext.classList.add('disabled');
    //     document.getElementById('no-data-two').classList.add('visuallyhidden');
    //     (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null;
    //   })
    //
    //   // Third Step
    //   milesField.addEventListener('input', () => {
    //     (milesField.value > 0 && milesField.value <= 9999) ? stepTwoNext.classList.remove('disabled') : stepTwoNext.classList.add('disabled')
    //   })
    //   document.querySelector('#route-button-auto').addEventListener('click', (e) => {
    //     document.querySelector('#route-button-auto').classList.remove('button-outline')
    //     document.querySelector('#route-button-manual').classList.add('button-outline')
    //     document.querySelector('.route-auto').classList.remove('visuallyhidden')
    //     document.querySelector('.route-manual').classList.add('visuallyhidden')
    //   })
    //   document.querySelector('#route-button-manual').addEventListener('click', (e) => {
    //     document.querySelector('#route-button-auto').classList.add('button-outline')
    //     document.querySelector('#route-button-manual').classList.remove('button-outline')
    //     document.querySelector('.route-auto').classList.add('visuallyhidden')
    //     document.querySelector('.route-manual').classList.remove('visuallyhidden')
    //   })
    //
    //   // Fourth Step
    //   electricityField.addEventListener('input', () => {
    //     if(electricityField.value > 0 && electricityField.value <= 50){
    //       document.querySelector('#step-three-next').classList.remove('disabled')
    //     } else {
    //       document.querySelector('#step-three-next').classList.add('disabled')
    //     }
    //   })
    //   document.querySelector('#electricity-cost-button-auto').addEventListener('click', (e) => {
    //     // document.querySelector('#electricity-cost-button-auto').classList.remove('button-outline')
    //     // document.querySelector('#electricity-cost-button-manual').classList.add('button-outline')
    //     // document.querySelector('#electricity-cost-average').classList.remove('visuallyhidden')
    //     // electricityField.classList.add('visuallyhidden')
    //     // electricityLabel.classList.add('visuallyhidden')
    //     // electricityField.value = document.querySelector('#electricity-cost').getAttribute('data-average')
    //     // electricityField.dispatchEvent(new Event('input'))
    //     (charger_rate == '150') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-ultra') : ( (charger_rate == '50') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-rapid') : averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity') );
    //     document.querySelector('#electricity-cost').setAttribute('data-average', averageValue);
    //     electricityField.value = averageValue
    //     electricityField.dispatchEvent(new Event('input'))
    //   })
    //
    //   // document.querySelector('#electricity-cost-button-manual').addEventListener('click', (e) => {
    //   //   document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
    //   //   document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
    //   //   document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
    //   //   electricityField.classList.remove('visuallyhidden')
    //   //   electricityLabel.classList.remove('visuallyhidden')
    //   //   electricityField.dispatchEvent(new Event('input'))
    //   // })
    //
    //   // Reset Form
    //   function resetForm() {
    //     let compareButton = document.querySelector('button[data-compare]');
    //     if (compareButton) {
    //       compareButton.dataset.compare = '';
    //       compareButton.dataset.name = '';
    //       compareButton.setAttribute('title', `Compare deal`);
    //       compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/bluepoppy/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
    //       compareButton.dataset.compareAdded = 'false';
    //     }
    //
    //     document.querySelector('#progress').value = 1;
    //     document.querySelector('#progress-text').innerHTML = '0';
    //
    //     document.getElementById('car-image').setAttribute('src', '/themes/bluepoppy/img/icons/car-comparison-placeholder.svg');
    //     document.getElementById("journey-calculator-form").reset();
    //     derivativeField.classList.add('visuallyhidden')
    //     derivativeFieldCompare.classList.add('visuallyhidden')
    //     document.querySelectorAll('.journey-calculator-form > .step').forEach((value) => {
    //       value.classList.remove('active')
    //       value.classList.contains('step-one') ? value.classList.add('active') : null;
    //     })
    //     document.querySelectorAll('.next-step').forEach((value) => { value.classList.add('disabled') })
    //     document.getElementById('journey-calculator-route-text').innerText = '';
    //   }
    //   setTimeout(resetForm, 500);
    //   document.querySelectorAll('.start-again').forEach((value) => {
    //     value.addEventListener('click', resetForm)
    //   })
    //
    //   // Calculate
    //   document.querySelector('#step-three-next').addEventListener('click', (e) => {
    //     let journey_frequency = parseInt(document.querySelector('input[name="frequency"]:checked').value);
    //     let london_frequency = parseInt(document.querySelector('input[name="london"]:checked').value);
    //     let ulez_frequency = parseInt(document.querySelector('input[name="ulez"]:checked').value);
    //     let pence_per_kwh = parseInt(electricityField.value);
    //     journey_distance = parseInt(milesField.value);
    //
    //     // First Car
    //     document.getElementById('car-image').setAttribute('onerror', `this.src="${img_url}"`);
    //     img_url.includes('/std/') ? img_url = img_url.replace('/std/', '/big/') : null;
    //     document.getElementById('car-image').setAttribute('src', img_url);
    //     document.getElementById('summary-co2').innerText = parseInt(co2).toFixed(0) + 'g/km';
    //     // document.getElementById('summary-nox').innerText = nox;
    //
    //     let indicative_fuel_cost = indicativeCost('Electric', null, electric_range, battery_capacity, pence_per_kwh)
    //     document.getElementById('summary-per-mile').innerText = parseFloat(indicative_fuel_cost).toFixed(1) + 'p'
    //
    //     journey_cost = (journey_distance * indicative_fuel_cost) / 100; // journey cost (pound)
    //     document.getElementById('summary-journey').innerText = '£' + numberWithCommas(journey_cost.toFixed(2));
    //
    //     annual_journey_cost = journey_frequency * journey_cost;
    //     document.getElementById('summary-annual').innerText = '£' + numberWithCommas(annual_journey_cost.toFixed(2))
    //     document.getElementById('summary-monthly').innerText = '£' + numberWithCommas((annual_journey_cost/12).toFixed(2))
    //
    //     // Second Car
    //     document.getElementById('car-image-second').setAttribute('onerror', `this.src="${comparable_img_url}"`);
    //     comparable_img_url.includes('/std/') ? comparable_img_url = comparable_img_url.replace('/std/', '/big/') : null;
    //     document.getElementById('car-image-second').setAttribute('src', comparable_img_url);
    //     document.getElementById('summary-co2-second').innerText = parseInt(comparable_co2).toFixed(0) + 'g/km';
    //     // document.getElementById('summary-nox-second').innerText = comparable_nox;
    //
    //     let comparable_indicative_fuel_cost = indicativeCost(comparable_type, comparable_mpg, false, false, pence_per_kwh);
    //     document.getElementById('summary-per-mile-second').innerText = parseFloat(comparable_indicative_fuel_cost).toFixed(1) + 'p';
    //
    //     comparable_journey_cost = (journey_distance * comparable_indicative_fuel_cost) / 100; // journey cost (pound)
    //     document.getElementById('summary-journey-second').innerText = '£' + numberWithCommas(comparable_journey_cost.toFixed(2));
    //
    //     comparable_annual_journey_cost = journey_frequency * comparable_journey_cost;
    //     document.getElementById('summary-annual-second').innerText = '£' + numberWithCommas(comparable_annual_journey_cost.toFixed(2))
    //     document.getElementById('summary-monthly-second').innerText = '£' + numberWithCommas((comparable_annual_journey_cost/12).toFixed(2))
    //
    //     document.getElementById('summary-london-daily-second').innerText = '£' + numberWithCommas(((london_frequency == 0) ? 0 : comparable_london).toFixed(2));
    //     document.getElementById('summary-ulez-daily-second').innerText = '£' + numberWithCommas(((ulez_frequency == 0) ? 0 : comparable_ulez).toFixed(2));
    //     document.getElementById('summary-london-annual-second').innerText = '£' + numberWithCommas((london_frequency * comparable_london).toFixed(2));
    //     document.getElementById('summary-ulez-annual-second').innerText = '£' + numberWithCommas((ulez_frequency * comparable_ulez).toFixed(2));
    //     // let comparable_journey_cost = (journey_distance * comparable_indicative_cost) / 100; // journey cost (pound)
    //     // let comparable_annual_journey_cost = journey_frequency * comparable_journey_cost;
    //     // let comparable_three_year_saving = (comparable_annual_journey_cost - annual_journey_cost) * 3;
    //     // document.getElementById('summary-estimated-saving').innerText = '£' + comparable_three_year_saving.toFixed(0)
    //
    //     let total_journey_saving = ((comparable_journey_cost - journey_cost) + ((london_frequency == 0) ? 0 : comparable_london) + ((ulez_frequency == 0) ? 0 : comparable_ulez));
    //     let total_annual_saving = (total_journey_saving * journey_frequency);
    //     let total_co2_saving = numberWithCommas((comparable_co2 * journey_frequency).toFixed(0)) + 'g/km';
    //     // let total_three_year_saving = (((comparable_journey_cost - journey_cost) * journey_frequency) * 3);
    //
    //     document.getElementById('summary-savings-total').innerText = '£' + numberWithCommas(total_journey_saving.toFixed(2));
    //     document.getElementById('summary-savings-annual').innerText = '£' + numberWithCommas(total_annual_saving.toFixed(2));
    //     document.getElementById('summary-savings-co2').innerText = total_co2_saving;
    //     // document.getElementById('summary-estimated-saving').innerText = '£' + total_three_year_saving.toFixed(2);
    //
    //     equalHeight(document.querySelector('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-header'), document.querySelector('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-header'))
    //     let left = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-body > div > p');
    //     let right = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-body > div > p');
    //     for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
    //   })
    //   window.addEventListener('resize', function(event) {
    //     equalHeight(document.querySelector('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-header'), document.querySelector('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-header'))
    //     let left = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-body > div > p');
    //     let right = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-body > div > p');
    //     for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
    //   }, true);
    // }
    // // Tax Calculator
    // if (document.querySelector('.tools-main>div').classList.contains('tax-calculator')) {
    //   loadManufacturersCalc('car', true);
    //   let makeField = document.querySelector('select[name=calculator-make]')
    //   let modelField = document.querySelector('select[name=calculator-model]')
    //   let derivativeField = document.querySelector('select[name=calculator-derivative]')
    //   let makeFieldCompare = document.querySelector('select[name=calculator-make-compare]')
    //   let modelFieldCompare = document.querySelector('select[name=calculator-model-compare]')
    //   let derivativeFieldCompare = document.querySelector('select[name=calculator-derivative-compare]')
    //   let stepOneNext = document.querySelector('#step-one-next')
    //   let stepTwoNext = document.querySelector('#step-two-next')
    //   let tax_band = 20;
    //   let ev_loaded, ice_loaded = false;
    //   let fuel_type, img_url, p11d, bik1, bik2, bik3, indicative_fuel_cost, co2;
    //   let comparable_value, comparable_type, comparable_img_url, comparable_mpg, comparable_p11d, comparable_bik1, comparable_bik2, comparable_bik3, comparable_indicative_fuel_cost, comparable_co2;
    //
    //   function loadVehicle($derivative, $ev = false) {
    //     let url = '/api/car/' + $derivative;
    //     fetch(url).then(function(response) {
    //       if (response.status !== 200) {
    //         console.warn('Looks like there was a problem. Status Code: ' + response.status);
    //         return;
    //       }
    //       return response.json();
    //     }).then(function(data) {
    //       // console.log(data)
    //       if ($ev) {
    //         co2 = (data.car.co2) ? data.car.co2 : null;
    //         bik1 = (data.car.tax) ? data.car.tax.Year1 : null;
    //         bik2 = (data.car.tax) ? data.car.tax.Year2 : null;
    //         bik3 = (data.car.tax) ? data.car.tax.Year3 : null;
    //         p11d = (data.car.base_price) ? data.car.base_price : null;
    //         img_url = (data.car.main_img) ? data.car.main_img : null;
    //         fuel_type = (data.car.fuel_type) ? data.car.fuel_type : null;
    //         // ved_first = data.car.tax_band.rate;
    //         // ved_annual = data.car.tax_band.second_rate;
    //         indicative_fuel_cost = indicativeCost(fuel_type, null, (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
    //         setTimeout(() => {
    //           if (co2 && img_url && fuel_type && bik1 != null && data.car.electric_range && data.car.battery_capacity) {
    //             ev_loaded = true;
    //             document.getElementById('no-data').classList.add('visuallyhidden');
    //             (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ice_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
    //           } else {
    //             ev_loaded = false;
    //             document.getElementById('no-data').classList.remove('visuallyhidden');
    //           }
    //         }, 1000);
    //
    //         let compareButton = document.querySelector('button[data-compare]');
    //         if (compareButton) {
    //           compareButton.dataset.compare = data.car.id;
    //           compareButton.dataset.name = data.car.model_name;
    //           compareButton.setAttribute('title', `Compare ${data.car.model_name} deal`);
    //           compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/bluepoppy/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
    //           compareButton.dataset.compareAdded = 'false';
    //           let cookie = Cookies.get('compare_list');
    //           if (cookie) {
    //             let cookie_obj = JSON.parse(cookie);
    //             if (cookie_obj[compareButton.dataset.compare] !== undefined) {
    //               compareButton.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/bluepoppy/img/minus.svg#minus"></use></svg>&nbsp;Remove`;
    //               compareButton.dataset.compareAdded = 'true';
    //             }
    //           }
    //         }
    //         document.querySelectorAll('.step-four-derivative').forEach(v => { v.innerHTML = derivativeField.options[derivativeField.selectedIndex].text });
    //       } else {
    //         comparable_type = data.car.fuel_type;
    //         if (comparable_type === 'Electric') {
    //           setTimeout(() => {
    //             ice_loaded = false;
    //             stepOneNext.classList.add('disabled');
    //             document.getElementById('no-ice-two').classList.remove('visuallyhidden');
    //           }, 500);
    //         } else {
    //           comparable_co2 = data.car.co2;
    //           comparable_img_url = data.car.main_img;
    //           comparable_p11d = data.car.base_price;
    //           // comparable_ved_first = data.car.tax_band.rate;
    //           // comparable_ved_annual = data.car.tax_band.second_rate;
    //           comparable_value = data.car.base_price;
    //           comparable_bik1 = data.car.tax.Year1;
    //           comparable_bik2 = data.car.tax.Year2;
    //           comparable_bik3 = data.car.tax.Year3;
    //           comparable_mpg = (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra);
    //           comparable_indicative_fuel_cost = indicativeCost(comparable_type, comparable_mpg, null, null);
    //           setTimeout(() => {
    //             if (comparable_value && comparable_bik1 != null && comparable_mpg && comparable_co2) {
    //               ice_loaded = true;
    //               document.getElementById('no-data-two').classList.add('visuallyhidden');
    //               document.getElementById('no-ice-two').classList.add('visuallyhidden');
    //               (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ev_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
    //             } else {
    //               ice_loaded = false;
    //               document.getElementById('no-data-two').classList.remove('visuallyhidden');
    //             }
    //           }, 1000);
    //           document.querySelectorAll('.step-four-derivative-second').forEach(v => { v.innerHTML = derivativeFieldCompare.options[derivativeFieldCompare.selectedIndex].text });
    //         }
    //       }
    //     }).catch(function(err) {
    //       console.error('Fetch Error -', err);
    //     });
    //   }
    //
    //   // First Step
    //   makeField.addEventListener('change', () => {
    //     (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : null;
    //     (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
    //     Array.prototype.slice.call(document.querySelectorAll('.step-three-make'), 0).forEach((value) => {
    //       value.innerHTML = makeField.options[makeField.selectedIndex].text
    //     })
    //     derivativeField.classList.add('visuallyhidden')
    //     let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase();
    //     document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
    //   })
    //   modelField.addEventListener('change', () => {
    //     (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, true, false) : null; // inactive reversed
    //     Array.prototype.slice.call(document.querySelectorAll('.step-three-model'), 0).forEach((value) => {
    //       value.innerHTML = modelField.options[modelField.selectedIndex].text
    //     })
    //     let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
    //     document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
    //     derivativeField.classList.remove('visuallyhidden')
    //
    //     document.getElementById('no-data').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //
    //     setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null }, 500);
    //   })
    //   derivativeField.addEventListener('change', () => {
    //     stepOneNext.classList.add('disabled');
    //     document.getElementById('no-data').classList.add('visuallyhidden');
    //     (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null;
    //   })
    //
    //   // Second Step
    //   makeFieldCompare.addEventListener('change', () => {
    //     (makeFieldCompare.value > 0) ? loadModelsCalc('car', makeFieldCompare.value, false, false, true) : null;
    //     (modelFieldCompare.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
    //     derivativeFieldCompare.classList.add('visuallyhidden')
    //     let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase();
    //     document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond)
    //     document.querySelectorAll('.step-four-make-second').forEach(v => { v.innerHTML = makeFieldCompare.options[makeFieldCompare.selectedIndex].text });
    //     document.getElementById('no-data-two').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //   })
    //   modelFieldCompare.addEventListener('change', () => {
    //     (modelFieldCompare.value > 0) ? loadDerivativeCalc('car', modelFieldCompare.value, false, false, true, true, true, true) : null;
    //     document.querySelectorAll('.step-four-model-second').forEach(v => { v.innerHTML = modelFieldCompare.options[modelFieldCompare.selectedIndex].text });
    //     let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelFieldCompare.options[modelFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
    //     document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond)
    //     derivativeFieldCompare.classList.remove('visuallyhidden')
    //
    //     document.getElementById('no-data-two').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //
    //     setTimeout(() => { (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null }, 500);
    //   })
    //   derivativeFieldCompare.addEventListener('change', () => {
    //     stepOneNext.classList.add('disabled');
    //     document.getElementById('no-data-two').classList.add('visuallyhidden');
    //     (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null;
    //   })
    //
    //   // Third Step - Company Switch
    //   // document.querySelectorAll('input[name=company]').forEach((value) => {
    //   //   value.addEventListener('change', (e) => {
    //   //     (e.target.value === 'yes') ? company_car = true : company_car = false;
    //   //     (e.target.value === 'yes') ? tax_band = 20 : tax_band = 0;
    //   //     (e.target.value === 'yes') ? taxBand.classList.remove('visuallyhidden') : taxBand.classList.add('visuallyhidden');
    //   //     (e.target.value === 'yes') ? stepThreeNext.classList.add('disabled') : stepThreeNext.classList.remove('disabled')
    //   //   })
    //   // })
    //
    //   // Third Step - Tax Band Switch
    //   document.querySelector('select[name=calculator-tax-band]').addEventListener('change', (e) => {
    //     // (e.target.value > 0) ? stepTwoNext.classList.remove('disabled') : stepTwoNext.classList.add('disabled');
    //     (e.target.value === '20') ? tax_band = 20 : tax_band = 40;
    //     document.querySelectorAll('.tax-payable').forEach((value => {value.innerHTML = e.target.value}))
    //   })
    //
    //   // Fourth Step - Frequency Switch
    //   // document.querySelectorAll('input[name=frequency]').forEach((value) => {
    //   //   value.addEventListener('change', (e) => {
    //   //     congestion_charge_freq = e.target.value
    //   //   })
    //   // })
    //
    //   function calculateBIK($p11d, $bik_rate) {
    //     return ($p11d * ($bik_rate / 100));
    //   }
    //   function calculateTAX($p11d, $bik_rate, $tax_rate = 0) {
    //     return ($p11d * ($bik_rate / 100)) * ($tax_rate / 100);
    //   }
    //   // function calculateNIC($p11d, $bik_rate, $nic_rate = 13.80) {
    //   //   return ($p11d * ($bik_rate / 100)) * ($nic_rate / 100);
    //   // }
    //
    //   // Calculate
    //   stepTwoNext.addEventListener('click', (e) => {
    //     // let ved_total = (ved_first + (2 * ved_annual));
    //     let bik_total = (calculateBIK(p11d, bik1, tax_band) + calculateBIK(p11d, bik2, tax_band) + calculateBIK(p11d, bik3, tax_band)).toFixed(0);
    //     let tax_total = (calculateTAX(p11d, bik1, tax_band) + calculateTAX(p11d, bik2, tax_band) + calculateTAX(p11d, bik3, tax_band)).toFixed(0);
    //
    //     document.getElementById('car-image').setAttribute('onerror', `this.src="${img_url}"`);
    //     img_url.includes('/std/') ? img_url = img_url.replace('/std/', '/big/') : null;
    //     document.getElementById('car-image').setAttribute('src', img_url)
    //     document.getElementById('summary-type').innerText = fuel_type
    //     // document.getElementById('summary-ved-first').innerText = '£' + ved_first
    //     // document.getElementById('summary-ved-annual').innerText = '£' + ved_annual
    //     // document.getElementById('summary-ved-total').innerText = '£' + ved_total
    //     document.getElementById('summary-p11d').innerText = '£' + numberWithCommas((p11d))
    //     document.getElementById('summary-co2').innerText = parseInt(co2).toFixed(0) + 'g/km'
    //     document.getElementById('summary-bik1').innerText = '£' + numberWithCommas((calculateBIK(p11d, bik1)).toFixed(0))
    //     document.getElementById('summary-bik2').innerText = '£' + numberWithCommas((calculateBIK(p11d, bik2)).toFixed(0))
    //     document.getElementById('summary-bik3').innerText = '£' + numberWithCommas((calculateBIK(p11d, bik3)).toFixed(0))
    //     document.getElementById('summary-bik1tax').innerText = '£' + numberWithCommas((calculateTAX(p11d, bik1, tax_band)).toFixed(0))
    //     document.getElementById('summary-bik2tax').innerText = '£' + numberWithCommas((calculateTAX(p11d, bik2, tax_band)).toFixed(0))
    //     document.getElementById('summary-bik3tax').innerText = '£' + numberWithCommas((calculateTAX(p11d, bik3, tax_band)).toFixed(0))
    //     document.getElementById('summary-bik1rate').innerText = (bik1) + '%'
    //     document.getElementById('summary-bik2rate').innerText = (bik2) + '%'
    //     document.getElementById('summary-bik3rate').innerText = (bik3) + '%'
    //     // document.getElementById('summary-bik4').innerText = '£' + bik_total
    //     document.getElementById('summary-fuel').innerText = (indicative_fuel_cost) + 'p/mile'
    //
    //     // let comparable_ved_total = (comparable_ved_first + (2 * comparable_ved_annual));
    //     let comparable_bik_total = (calculateBIK(comparable_p11d, comparable_bik1, tax_band) + calculateBIK(comparable_p11d, comparable_bik2, tax_band) + calculateBIK(comparable_p11d, comparable_bik3, tax_band)).toFixed(0);
    //     let comparable_tax_total = (calculateTAX(comparable_p11d, comparable_bik1, tax_band) + calculateTAX(comparable_p11d, comparable_bik2, tax_band) + calculateTAX(comparable_p11d, comparable_bik3, tax_band)).toFixed(0);
    //
    //     document.getElementById('car-image-second').setAttribute('onerror', `this.src="${comparable_img_url}"`);
    //     comparable_img_url.includes('/std/') ? comparable_img_url = comparable_img_url.replace('/std/', '/big/') : null;
    //     document.getElementById('car-image-second').setAttribute('src', comparable_img_url);
    //     document.getElementById('summary-type-second').innerText = comparable_type
    //     // document.getElementById('summary-ved-first-second').innerText = '£' + comparable_ved_first
    //     // document.getElementById('summary-ved-annual-second').innerText = '£' + comparable_ved_annual
    //     // document.getElementById('summary-ved-total-second').innerText = '£' + comparable_ved_total
    //     document.getElementById('summary-p11d-second').innerText = '£' + numberWithCommas((comparable_p11d))
    //     document.getElementById('summary-co2-second').innerText = parseInt(comparable_co2).toFixed(0) + 'g/km'
    //     document.getElementById('summary-bik1-second').innerText = '£' + numberWithCommas((calculateBIK(comparable_p11d, comparable_bik1)).toFixed(0))
    //     document.getElementById('summary-bik2-second').innerText = '£' + numberWithCommas((calculateBIK(comparable_p11d, comparable_bik2)).toFixed(0))
    //     document.getElementById('summary-bik3-second').innerText = '£' + numberWithCommas((calculateBIK(comparable_p11d, comparable_bik3)).toFixed(0))
    //     document.getElementById('summary-bik1tax-second').innerText = '£' + numberWithCommas((calculateTAX(comparable_p11d, comparable_bik1, tax_band)).toFixed(0))
    //     document.getElementById('summary-bik2tax-second').innerText = '£' + numberWithCommas((calculateTAX(comparable_p11d, comparable_bik2, tax_band)).toFixed(0))
    //     document.getElementById('summary-bik3tax-second').innerText = '£' + numberWithCommas((calculateTAX(comparable_p11d, comparable_bik3, tax_band)).toFixed(0))
    //     document.getElementById('summary-bik1rate-second').innerText = (comparable_bik1) + '%'
    //     document.getElementById('summary-bik2rate-second').innerText = (comparable_bik2) + '%'
    //     document.getElementById('summary-bik3rate-second').innerText = (comparable_bik3) + '%'
    //     // document.getElementById('summary-bik4-second').innerText = '£' + comparable_bik_total
    //     document.getElementById('summary-fuel-second').innerText = (comparable_indicative_fuel_cost) + 'p/mile'
    //
    //     document.getElementById('summary-total-tax').innerText = '£' + numberWithCommas((tax_total));
    //     document.getElementById('summary-total-tax-second').innerText = '£' + numberWithCommas((comparable_tax_total));
    //     document.getElementById('summary-total-savings').innerText = '£' + numberWithCommas(((parseFloat(comparable_tax_total)) - (parseFloat(tax_total))));
    //
    //     // let comparable_tax_amount;
    //     // let comparable_bik_rate = (comparable_bik / 100) * comparable_value;
    //     // (tax_band === 0) ? comparable_tax_amount = comparable_bik_rate : comparable_tax_amount = (tax_band / 100) * comparable_bik_rate;
    //     // document.getElementById('summary-total-tax').innerText = '£' + (ved_total + ((fuel_type === 'Electric') ? 0 : ((congestion_charge * congestion_charge_freq) * 3)))
    //     // document.getElementById('summary-total-savings').innerText = '£' + ((fuel_type !== 'Electric') ? 0 : (((parseFloat(congestion_charge) * parseFloat(congestion_charge_freq)) + parseFloat(comparable_tax_amount)) * 3)).toFixed(0)
    //
    //     equalHeight(document.querySelector('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-header'), document.querySelector('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-header'))
    //     let left = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-body > div > p');
    //     let right = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-body > div > p');
    //     for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
    //   })
    //
    //   // Reset Form
    //   function resetForm() {
    //     let compareButton = document.querySelector('button[data-compare]');
    //     if (compareButton) {
    //       compareButton.dataset.compare = '';
    //       compareButton.dataset.name = '';
    //       compareButton.setAttribute('title', `Compare deal`);
    //       compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/bluepoppy/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
    //       compareButton.dataset.compareAdded = 'false';
    //     }
    //
    //     document.querySelector('#progress').value = 1;
    //     document.querySelector('#progress-text').innerHTML = '0';
    //
    //     document.getElementById('car-image').setAttribute('src', '/themes/bluepoppy/img/icons/car-comparison-placeholder.svg');
    //     stepOneNext.classList.add('disabled')
    //     derivativeField.classList.add('visuallyhidden')
    //     derivativeFieldCompare.classList.add('visuallyhidden')
    //     document.getElementById("tax-calculator-form").reset()
    //     document.querySelectorAll('.tax-calculator-form > .step').forEach((value) => {
    //       value.classList.remove('active')
    //       value.classList.contains('step-one') ? value.classList.add('active') : null
    //     })
    //     document.querySelector('#step-one-next').classList.add('disabled')
    //   }
    //   setTimeout(resetForm, 500);
    //   document.querySelectorAll('.start-again').forEach((value) => {
    //     value.addEventListener('click', resetForm);
    //   })
    //
    //
    //   window.addEventListener('resize', function(event) {
    //     equalHeight(document.querySelector('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-header'), document.querySelector('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-header'))
    //     let left = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-body > div > p');
    //     let right = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-body > div > p');
    //     for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
    //   }, true);
    //
    // }
    // // Charging Time & Cost Calculator
    // if (document.querySelector('.tools-main>div').classList.contains('charging-calculator')) {
    //   loadManufacturersCalc('car', true);
    //   let makeField = document.querySelector('select[name=calculator-make]')
    //   let modelField = document.querySelector('select[name=calculator-model]')
    //   let derivativeField = document.querySelector('select[name=calculator-derivative]')
    //   let electricityField = document.querySelector('input[name=charging-calculator-electricity]')
    //   // let electricityLabel = document.querySelector('.electricity-cost-label')
    //   let rateSwitch = document.querySelectorAll('input[name=speed]')
    //   let stepOneNext = document.querySelector('#step-one-next')
    //   let slider = document.getElementById('chargePercentage');
    //   let output = document.getElementById('chargePercentageNumber');
    //   let button_url, electric_range, averageValue, charger_speed, charging_time, slow_kw, fast_kw, rapid_kw, ultra_kw, slow_time, fast_time, rapid_time, ultra_time, img_url, charger_rate, battery_capacity;
    //
    //   function loadVehicle($derivative) {
    //     let url = '/api/car/' + $derivative;
    //     fetch(url).then(function(response) {
    //       if (response.status !== 200) {
    //         console.warn('Looks like there was a problem. Status Code: ' + response.status);
    //         return;
    //       }
    //       return response.json();
    //     }).then(function(data) {
    //       let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
    //       img_url = data.car.main_img;
    //       battery_capacity = data.car.battery_capacity;
    //       electric_range = (data.car.electric_range != null) ? data.car.electric_range : ((data.car.technical) ? ((getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)')) ? parseFloat(getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)').value) : null) : null);
    //       // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow kW')) ? slow_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow kW').value : slow_kw = null;
    //       // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast kW')) ? fast_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast kW').value : fast_kw = null;
    //       // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow Time')) ? slow_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow Time').value : slow_time = null;
    //       // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast Time')) ? fast_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast Time').value : fast_time = null;
    //       // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid kW')) ? rapid_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid kW').value : rapid_kw = null;
    //       // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid Time')) ? rapid_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid Time').value : rapid_time = null;
    //       slow_kw = 7;
    //       fast_kw = 22;
    //       rapid_kw = 60;
    //       ultra_kw = 350;
    //       slow_time = (battery_capacity / slow_kw)*60;
    //       fast_time = (battery_capacity / fast_kw)*60;
    //       rapid_time = (battery_capacity / rapid_kw)*60;
    //       ultra_time = (battery_capacity / ultra_kw)*60;
    //
    //       setTimeout(() => {
    //         if (electric_range && slow_kw && battery_capacity && slow_time) {
    //           document.getElementById('car-image').setAttribute('onerror', `this.src="${img_url}"`);
    //           img_url.includes('/std/') ? img_url = img_url.replace('/std/', '/big/') : null;
    //           document.getElementById('car-image').setAttribute('src', img_url);
    //           document.getElementById('no-data').classList.add('visuallyhidden');
    //           document.getElementById('speed-slow').setAttribute('value', slow_kw);
    //           document.querySelector('#speed-slow-label > span').innerText = slow_kw;
    //           (derivativeField.childElementCount > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
    //           // button_url = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
    //           button_url = data.car.full_url
    //           document.querySelector('.view-range-button').setAttribute('href', button_url)
    //           // document.querySelector('button[data-compare]').setAttribute('data-compare', data.car.id)
    //
    //           Array.prototype.slice.call(document.querySelectorAll('.step-four-make'), 0).forEach((value) => {
    //             value.innerHTML = makeField.options[makeField.selectedIndex].text
    //           })
    //           Array.prototype.slice.call(document.querySelectorAll('.step-four-model'), 0).forEach((value) => {
    //             value.innerHTML = modelField.options[modelField.selectedIndex].text
    //           })
    //
    //           if (fast_kw && fast_time && parseFloat(fast_time) > 1 && parseFloat(fast_kw) > 1) {
    //             document.getElementById('speed-fast-label').style.display = 'block';
    //             document.getElementById('speed-fast').setAttribute('value', fast_kw);
    //             document.querySelector('#speed-fast-label > span').innerText = fast_kw;
    //           } else {
    //             document.getElementById('speed-fast-label').style.display = 'none';
    //           }
    //           if (rapid_kw && rapid_time && parseFloat(rapid_time) > 1 && parseFloat(rapid_kw) > 1) {
    //             document.getElementById('speed-rapid-label').style.display = 'block';
    //             document.getElementById('speed-rapid').setAttribute('value', rapid_kw);
    //             document.querySelector('#speed-rapid-label > span').innerText = rapid_kw;
    //           } else {
    //             document.getElementById('speed-rapid-label').style.display = 'none';
    //           }
    //         } else {
    //           document.getElementById('no-data').classList.remove('visuallyhidden');
    //         }
    //       }, 1000);
    //
    //       let compareButton = document.querySelector('button[data-compare]');
    //       if (compareButton) {
    //         compareButton.dataset.compare = data.car.id;
    //         compareButton.dataset.name = data.car.model_name;
    //         compareButton.setAttribute('title', `Compare ${data.car.model_name} deal`);
    //         compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/bluepoppy/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
    //         compareButton.dataset.compareAdded = 'false';
    //         let cookie = Cookies.get('compare_list');
    //         if (cookie) {
    //           let cookie_obj = JSON.parse(cookie);
    //           if (cookie_obj[compareButton.dataset.compare] !== undefined) {
    //             compareButton.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/bluepoppy/img/minus.svg#minus"></use></svg>&nbsp;Remove`;
    //             compareButton.dataset.compareAdded = 'true';
    //           }
    //         }
    //       }
    //       document.querySelectorAll('.step-four-derivative').forEach(v => { v.innerHTML = derivativeField.options[derivativeField.selectedIndex].text });
    //     }).catch(function(err) {
    //       console.error('Fetch Error -', err);
    //     });
    //   }
    //
    //   makeField.addEventListener('change', () => {
    //     (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : false;
    //     (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
    //     derivativeField.classList.add('visuallyhidden')
    //
    //     document.getElementById('no-data').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //   })
    //
    //   modelField.addEventListener('change', () => {
    //     (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, true, false) : false; // inactive reversed
    //
    //     derivativeField.classList.remove('visuallyhidden')
    //
    //     document.getElementById('no-data').classList.add('visuallyhidden')
    //     stepOneNext.classList.add('disabled')
    //
    //     setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value) : false }, 500);
    //   })
    //
    //   derivativeField.addEventListener('change', () => {
    //     stepOneNext.classList.add('disabled');
    //     document.getElementById('no-data').classList.add('visuallyhidden');
    //     (derivativeField.value > 0) ? loadVehicle(derivativeField.value) : false;
    //   })
    //
    //   electricityField.addEventListener('input', () => {
    //     if(electricityField.value > 0 && electricityField.value <= 50){
    //       document.querySelector('#step-three-next').classList.remove('disabled')
    //     } else {
    //       document.querySelector('#step-three-next').classList.add('disabled')
    //     }
    //   })
    //
    //   document.querySelector('#electricity-cost-button-auto').addEventListener('click', (e) => {
    //     // document.querySelector('#electricity-cost-button-auto').classList.remove('button-outline');
    //     // document.querySelector('#electricity-cost-button-manual').classList.add('button-outline');
    //     // document.querySelector('#electricity-cost-average').classList.remove('visuallyhidden');
    //     (charger_rate == '350') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-ultra') : ( (charger_rate == '60') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-rapid') : averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity') );
    //     // document.querySelector('#electricity-cost-average span').innerHTML = averageValue;
    //     document.querySelector('#electricity-cost').setAttribute('data-average', averageValue);
    //     // electricityField.classList.add('visuallyhidden')
    //     // electricityLabel.classList.add('visuallyhidden')
    //     electricityField.value = averageValue
    //     electricityField.dispatchEvent(new Event('input'))
    //   })
    //
    //   // document.querySelector('#electricity-cost-button-manual').addEventListener('click', (e) => {
    //   //   document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
    //   //   document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
    //   //   document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
    //   //   electricityField.classList.remove('visuallyhidden')
    //   //   electricityLabel.classList.remove('visuallyhidden')
    //   //   electricityField.dispatchEvent(new Event('input'))
    //   // })
    //
    //   // Calculate
    //   function calculate($percentage, $charger_rate, $electricity_cost, $electric_range, $battery_capacity, $charging_time) {
    //     function percentage(num, per){ return (num/100)*per }
    //     let indicative_cost = indicativeCost('Electric', null, $electric_range, $battery_capacity, $electricity_cost);
    //     let charge_cost = (parseFloat(indicative_cost) * parseFloat(percentage($electric_range, $percentage)))/100;
    //     document.getElementById('summary-miles').innerText = parseFloat(percentage($electric_range, $percentage)).toFixed(2) + ' miles';
    //     document.getElementById('summary-estimate').innerText = parseFloat(indicative_cost).toFixed(1) + 'p';
    //     document.getElementById('summary-cost').innerText = '£' + numberWithCommas(charge_cost.toFixed(2));
    //     document.getElementById('summary-time').innerText = (parseFloat(percentage($charging_time, $percentage))/60 < 1) ? parseFloat(percentage($charging_time, $percentage)).toFixed(0) + 'min' : (parseFloat(percentage($charging_time, $percentage))/60).toFixed(1) + 'h';
    //     document.getElementById('summary-kwh').innerText = parseFloat(percentage($battery_capacity, $percentage)).toFixed(0) + 'kWh';
    //   }
    //
    //   rateSwitch.forEach((value) => {
    //     value.addEventListener('change', (e) => {
    //       charger_rate = e.target.value;
    //       (e.target.dataset.speed === 'fast') ? charging_time = fast_time : ((e.target.dataset.speed === 'slow') ? charging_time = slow_time : charging_time = rapid_time);
    //       document.querySelector('#step-two-next').classList.remove('disabled');
    //     })
    //   })
    //
    //   document.querySelector('#step-three-next').addEventListener('click', (e) => {
    //     calculate(slider.value, charger_rate, electricityField.value, electric_range, battery_capacity, charging_time)
    //   })
    //
    //   output.innerHTML = slider.value;
    //   slider.oninput = function() {
    //     output.innerHTML = this.value
    //     calculate(this.value, charger_rate, electricityField.value, electric_range, battery_capacity, charging_time)
    //   }
    //
    //   // Reset Form
    //   function resetForm() {
    //     let compareButton = document.querySelector('button[data-compare]');
    //     if (compareButton) {
    //       compareButton.dataset.compare = '';
    //       compareButton.dataset.name = '';
    //       compareButton.setAttribute('title', `Compare deal`);
    //       compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/bluepoppy/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
    //       compareButton.dataset.compareAdded = 'false';
    //     }
    //
    //     document.querySelector('#progress').value = 1;
    //     document.querySelector('#progress-text').innerHTML = '0';
    //     output.innerHTML = '80';
    //
    //     document.getElementById('car-image').setAttribute('src', '/themes/bluepoppy/img/icons/car-comparison-placeholder.svg');
    //     document.getElementById("charging-calculator-form").reset();
    //     derivativeField.classList.add('visuallyhidden');
    //     document.querySelectorAll('.charging-calculator-form > .step').forEach((value) => {
    //       value.classList.remove('active')
    //       value.classList.contains('step-one') ? value.classList.add('active') : false;
    //     })
    //     document.querySelectorAll('.next-step').forEach((value) => { value.classList.add('disabled') })
    //
    //     // document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
    //     // document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
    //     // document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
    //     // electricityField.classList.remove('visuallyhidden')
    //     // electricityLabel.classList.remove('visuallyhidden')
    //   }
    //   setTimeout(resetForm, 500);
    //   document.querySelectorAll('.start-again').forEach((value) => {
    //     value.addEventListener('click', resetForm);
    //   })
    // }
  }


  // Add To Compare - Car
  document.querySelectorAll('button[data-compare][data-type="car"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
            e.target.innerHTML = `<svg width="18" height="15"><use xlink:href="/themes/bluepoppy/img/icons/compare-remove.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools/car-comparison" }
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools/car-comparison" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          e.target.innerHTML = `<svg width="18" height="15"><use xlink:href="/themes/bluepoppy/img/icons/compare-add.svg#plus"></use></svg>&nbsp;<span>Compare</span>`;
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Car Comparison')
            .setting({
              'title': 'Car Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/tools/car-comparison" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list', cookie_string)
        e.target.innerHTML = `<svg width="18" height="15"><use xlink:href="/themes/bluepoppy/img/icons/compare-remove.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Car Comparison')
          .setting({
            'title': 'Car Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/tools/car-comparison" }
          });
      }
    })
  })
  // Add To Compare - Van
  document.querySelectorAll('button[data-compare][data-type="van"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list_vans')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list_vans', cookie_string)
            e.target.innerHTML = `<svg width="18" height="15"><use xlink:href="/themes/bluepoppy/img/icons/compare-remove.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Van Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools/van-comparison" }
              });
          } else {
            alertify.confirm('Van Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `
                  <span class="semi-bold">Van Comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2218\\x22 height=\\x2215\\x22><use xlink:href=\\x22/themes/bluepoppy/img/icons/compare-add.svg#plus\\x22></use></svg>&nbsp;<span>Compare</span>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools/van-comparison" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
          e.target.innerHTML = `<svg width="18" height="15"><use xlink:href="/themes/bluepoppy/img/icons/compare-add.svg#plus"></use></svg>&nbsp;<span>Compare</span>`;
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Van Comparison')
            .setting({
              'title': 'Van Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/tools/van-comparison" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list_vans', cookie_string)
        e.target.innerHTML = `<svg width="18" height="15"><use xlink:href="/themes/bluepoppy/img/icons/compare-remove.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Van Comparison')
          .setting({
            'title': 'Van Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/tools/van-comparison" }
          });
      }
    })
  })

  // Compare Count
  function comparisonCount() {
    let car_count = 0;
    let cookie = Cookies.get('compare_list')
    if (Cookies.get('compare_list')) {
      let cookie_obj = JSON.parse(cookie);
      car_count = Object.keys(cookie_obj).length;
    }
    document.querySelectorAll('#comparison_counter').forEach(v => { v.innerText = car_count });
    let van_count = 0;
    let van_cookie = Cookies.get('compare_list_vans')
    if (Cookies.get('compare_list_vans')) {
      let van_cookie_obj = JSON.parse(van_cookie);
      van_count = Object.keys(van_cookie_obj).length;
    }
    document.querySelectorAll('#comparison_counter_van').forEach(v => { v.innerText = van_count });
  }
  comparisonCount();
  document.querySelectorAll('div[data-car] .reset, .alertify .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })
  let derivativeField = document.querySelector('#car-comparison select[name=calculator-derivative]');
  if (derivativeField) {
    derivativeField.addEventListener('change', (event) => {
      comparisonCount();
    })
  }
  document.querySelectorAll('div[data-car] .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })

  // Add To Favourites
  document.querySelectorAll('button[data-favourite]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('favourite_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.favourite] === undefined) {
          if (Object.keys(cookie_obj).length < 30) {
            cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('favourite_list', cookie_string)
            e.target.innerHTML = `<img width="18" src="/themes/bluepoppy/img/icons/favourites-remove.svg" alt="Favourites">&nbsp;<span>Favourites</span>&nbsp;`;
            e.target.dataset.favouriteAdded = 'true';
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to favourites
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          } else {
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">Favourites list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your favourites list add ${e.target.dataset.name} again.</span>
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.favourite];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list');
          e.target.innerHTML = `<img width="18" src="/themes/bluepoppy/img/icons/favourites-add.svg" alt="Favourites">&nbsp;<span>Favourites</span>`;
          e.target.dataset.favouriteAdded = 'false';
          document.querySelector('.car-comparison') ? e.target.closest('.deal-box').remove() : null;
          alertify.confirm('Your Favourites')
            .setting({
              'title': 'Your Favourites',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from favourites`,
              'labels': { ok: 'Go To Favourites', cancel: 'Close' },
              'onok': function(){ window.location.href = "/favourites" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('favourite_list', cookie_string)
        e.target.innerHTML = `<img width="18" src="/themes/bluepoppy/img/icons/favourites-remove.svg" alt="Favourites">&nbsp;<span>Favourites</span>`;
        e.target.dataset.favouriteAdded = 'true';
        alertify.confirm('Your Favourites')
          .setting({
            'title': 'Your Favourites',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to favourites`,
            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
            'onok': function(){ window.location.href = "/favourites" }
          });
      }
    })
  })

  // Charging Speeds
  if (document.querySelector('#charging-speeds')) {
    function isElementVisible(el) {
      let rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };
      if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;
      return (
        el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
    }
    function scrollAnimTriggerCheck() {
      if (isElementVisible(document.querySelector('#charging-speeds .deal-charging-legend'))) {
        const speedHome = parseInt(document.getElementById('progress_bar_home').getAttribute('data-speed'));
        const speedFast = parseInt(document.getElementById('progress_bar_fast').getAttribute('data-speed'));
        const speedRapid = parseInt(document.getElementById('progress_bar_rapid').getAttribute('data-speed'));
        const speedUltra = parseInt(document.getElementById('progress_bar_ultra').getAttribute('data-speed'));
        const homeWidth = (speedHome / speedHome) * 100;
        document.body.style.setProperty('--position-home', homeWidth);
        const fastWidth = (speedFast / speedHome) * 100;
        document.body.style.setProperty('--position-fast', fastWidth);
        const rapidWidth = (speedRapid / speedHome) * 100;
        document.body.style.setProperty('--position-rapid', rapidWidth);
        const ultraWidth = (speedUltra / speedHome) * 100;
        document.body.style.setProperty('--position-ultra', ultraWidth);

        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }

});

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#hamburger-search');

const modalMobileNav = new tingle.modal({
  footer: true,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML + document.querySelector('.nav-links').innerHTML) : null;

let searchOpened = false;
const modalMobileSearch = new tingle.modal({
  closeMethods: ['button'],
  cssClass: ['mobile-search','reversed'],
  closeLabel: 'Close Search',
  onOpen: function() {
    this.setContent(document.querySelector('.search-aside').innerHTML);
    document.querySelector('.search-aside').innerHTML = "";
    // addActiveType();
    searchOpened = true;
  },
  onClose: function () {
    if (searchOpened) {
      hamburgerSearch.classList.remove('is-active');
      document.querySelector('.search-aside').innerHTML = document.querySelector('.mobile-search .tingle-modal-box__content').innerHTML;
      this.setContent('');
      // addActiveType();
      searchOpened = false;
    }
  }
});

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});

// Search modal
const handleToggleSearch = () => {
  hamburgerSearch.classList.toggle('is-active');

  if(hamburgerSearch.classList.contains("is-active")) {
    modalMobileSearch.open();
  } else{
    modalMobileSearch.close();
  }
}
if(hamburgerSearch){
  hamburgerSearch.onclick = () => handleToggleSearch();
  hamburgerSearch.addEventListener('keyup', (event) => {
    if(event.keyCode === 13 || event.keyCode === 32) {
      handleToggleSearch();
    }
  });
}


/* Vehicle Filters Mobile */
const filterButton = document.querySelector('.search-filters-mobile .vehicle-filters');
const searchSidebar = document.querySelector('.search-aside');
const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
let modelSelected = 0;
let specSelected = 0;

if(filterButton && searchSidebar){
  const modalMobileFilters = new tingle.modal({
    footer: false,
    closeMethods: ['overlay', 'button', 'escape'],
    cssClass: ['mobile-sidebar'],
    beforeOpen: function () {
      modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
      specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
      searchSidebar ? modalMobileFilters.setContent(searchSidebar.outerHTML) : null;
      updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
    },
    onOpen: function () {
      let searchAside = document.querySelector('.search-content .search-aside');
      searchAside.remove();
      let headerHeight = updateMobileResultsBtn.offsetHeight;
      document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
      document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
      document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
      updateMobileResults();
    },
    onClose: function() {
      updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
      filterButton.parentElement.classList.remove('is-active');
      let searchTingle = document.querySelector('.tingle-modal-box__content .search-aside');
      document.querySelector('.search-content').prepend(searchTingle);
      loadSearchTriggers();
      updateSearchToggles();
    }
  });

  filterButton.addEventListener("click", function(e){
    filterButton.parentElement.classList.toggle('is-active');
    if(filterButton.parentElement.classList.contains("is-active")) {
      modalMobileFilters.open();
    } else{
      modalMobileFilters.close();
    }
  })
}

/* END MOBILE MODALS */


// Advanced Search
document.getElementById('toggleAdvanced') ? document.getElementById('toggleAdvanced').addEventListener('click', function(e){
  e.preventDefault();
  document.querySelector('.form select[name="budget"]').selectedIndex = 0;
  document.getElementById('search-bar').classList.toggle('search-advanced');
}) : null;

setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 2000);

document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});

window.onload = (function(){
  // preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");

  if (document.getElementsByClassName('search-aside').length > 0) {
    // Load Sidebar Search
    updateSearchToggles();
    loadSearchTriggers();
    // addActiveType();
  }
});